import React, { useState, useRef, useEffect } from "react";
import Container from "../../components/layout/Container/Container";
import { defaultAppContextData } from "../../services/appData";
import Footer from "../../components/molecules/Footer/Footer";
import { IPersonalInfo } from "../../typings/models/PersonalInfo";
import Header from "../../components/molecules/Header/Header";
import "../../styles/LabStyles.css";
import FileSaver from "file-saver";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { IChooseApp } from "../../typings/models/ChooseApp";
import "react-datepicker/dist/react-datepicker.css";
import { faCopy, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { Modal, Button, Spinner, Tab, Tabs } from "react-bootstrap";
import { useContextService } from "../../services";
import { faCalendarAlt, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import {
  getPSHIndividualTests,
  getSampleNamesbyType,
  SavePSHDraftApplications,
  getPSHApplication,
  saveLabCancellation,
  getSampleNames,
  getSampleDescriptionbyType,
  getSampleLocTypeDist,
  getLabMaster,
  getLabCountries,
  getPSHPackages,
} from "../../api/apimethods";
import fetchCountryOptions from "../../scripts/countryOptions";
import { IcountryOptions } from "../../typings/models/CountryOption";
import moment from "moment";
import { ITestPshCavsCodeMasterModel } from "../../typings/models/PshCavsTestCodeMasterModel";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import { ISampleNameModel } from "../../typings/models/SampleNameModel";
import { ISampleDescriptionModel } from "../../typings/models/SampleDescriptionModel";
import { ISampleLocTypeDistrictModel } from "../../typings/models/SampleLocTypeDistrictModel";
import Stepwizard from "../LabDetails/Helper/Stepwizard";
import { notify } from "../../utils";
import { ErrMsg, NotifyType } from "../../utils/app-config";
import { ISampleSeverity } from "../../typings/models/SampleSeverity";
import { ISampleDiseaseDistribution } from "../../typings/models/SampleDiseaseDistribution";
import { ILabTestDetails } from "../../typings/models/LabTestDetails";
import { ILabCountries } from "../../typings/models/LabCountries";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import { helper } from "../../utils/helper";
import { IProjectDetails } from "../../typings/models/ProjectDetails";
import PersonalInformation, {
  initialPersonalInfo,
} from "./Helper/ProfileInformation";
import Select from "react-select";
import { IReactSelectOption } from "../../typings/models/ReactSelectOption";
import { SingleValue, ActionMeta } from "react-select";
import { useSearchParams } from "react-router-dom";
import { TypeOfApplicationEnum } from "../../utils/enum";
import {
  ILabSampleModelRequest,
  IPSHApplicationStatus,
  defAppStatus,
  defCancelAppStatus,
} from "../../typings/interfaces/Requests/LabSampleModelRequest";
import {
  IFilerInformation,
  tempFilerInfo,
} from "../../typings/models/FilerInformation";
import { SampleData } from "../../typings/models/SampleData";
import Loader from "../../components/molecules/Loader";

export interface PersonalInformationProps {
  profileInfo?: IPersonalInfo;
  modeOfPayment?: string;
  onModeOfPaymentChange?: (value: string) => void;
}
interface IAddress {
  postalCode: string;
  blockHouseNo: string;
  streetName: string;
  floorLevel: string;
  unit: string;
  buildingName: string;
}
interface BAddress {
  postalCode: string;
  blockHouseNo: string;
  streetName: string;
  floorLevel: string;
  unit: string;
  buildingName: string;
}
export interface PersonalInfo {
  customerName: string;
  mobileNumber: string;
  email: string;
  address: IAddress;
  billingAddress: BAddress;
  nric: string;
  homeNumber: string;
  paymentMethod: string;
}
export interface PackageDetails {
  id: string;
  name: string;
  testSelectionLimit: number;
}

enum mandatoryFields {
  marking = "marking",
  sampleType = "sampleType",
  sampleName = "sampleName",
  sampleDesc = "sampleDesc",
  labTestDetails = "labTestDetails",
  samplingDate = "samplingDate",
  sampleLocation = "sampleLocation",
  signsOrSymptoms = "signsOrSymptoms",
  diseaseDistribution = "diseaseDistribution",
  severity = "severity",
  district = "district",
  country = "country",
}

const SamplesAndTests = () => {
  const [params, setParams] = useSearchParams();
  const { message } = notify();
  const { btnLoaderHandler, fileToBase64, getFilerInfomation } = helper();
  const inputCountryRef = useRef(true);
  const [reportgenerated, setreportgenerated] = useState<number>(0);
  const location = useLocation();
  const state = location.state as {
    personalInfo: PersonalInfo;
    selectedType: string;
  };
  const [hasFetchedInitialData, setHasFetchedInitialData] = useState(false);
  const navigate = useNavigate();
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;
  const [districtOptions, setdistrictOptions] = useState<
    ISampleLocTypeDistrictModel[]
  >([]);
  const visibleSampleDesc = [
    "Soil",
    "Top Soil",
    "Soil Mix",
    "Sand",
    "Approved Soil Mix",
    "Compost",
  ];
  const [district, setDistrict] = useState<string>("");
  const [acknowledgmentMessage, setAcknowledgmentMessage] = useState<
    string | null
  >(null);
  const [personalInfo, setPersonalInfo] =
    useState<IPersonalInfo>(initialPersonalInfo);
  const [copyCount, setCopyCount] = useState<number>(1);
  const [districtError, setDistrictError] = useState<string | null>(null);
  const [cancelMessage, setcancelMessage] = useState<string | null>(null);
  const [countryError, setcountryError] = useState<string | null>(null);
  const [LocationError, setLocationError] = useState<string | null>(null);
  const [acknowledgmentNumber, setAcknowledgmentNumber] = useState<string>("");
  const [packageDetails, setPackageDetails] = useState<PackageDetails>({
    id: "",
    name: "",
    testSelectionLimit: 0,
  });
  const [sampletypeOptions, setSampleTypeOptions] = useState<
    ICodeMasterModel[]
  >([]);
  const [samplenameOptionsBak, setSampleNameOptionsBak] = useState<
    ISampleNameModel[]
  >([]);
  const [descriptionOptions, setDescriptionOptions] = useState<string[][]>([]);
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [cancelComments, setCancelComments] = useState<string>("");
  const [cancelCommentsErrMsg, setCancelCommentsErrMsg] = useState<string>("");
  const [testSelectionLimit, setTestSelectionLimit] = useState(0);
  const [filteredDistricts, setFilteredDistricts] = useState<
    ISampleLocTypeDistrictModel[]
  >([]);
  const [packages, setPackages] = useState<ITestPshCavsCodeMasterModel[]>([]);
  const [testOptions, setTestOptions] = useState<ITestPshCavsCodeMasterModel[]>(
    []
  );
  const [cancelButtonHidden, setCancelButtonHidden] = useState(false);
  const [selectionOption, setSelectionOption] = useState("");
  const [IsInitialSelected, setIsInitialSelected] = useState("");
  const [testDescription, setTestDescription] = useState<string>("");
  const [submittedFeedback, setSubmittedFeedback] = useState<number>(0);
  const [selectedSampleType, setSelectedSampleType] = useState<string[]>([]);
  const [selectedSampleDesc, setSelectedSampleDesc] = useState<string[]>([]);
  const [applicationNum, setApplicationNum] = useState<string>("");
  const [showDistrictSearchModal, setShowDistrictSearchModal] = useState(false);
  const [actionType, setActionType] = useState<string>("");
  const [showDistrictOptions, setShowDistrictOptions] =
    useState<boolean>(false);
  const [sampleLocation, setSampleLocation] = useState("");
  const [defaultDistrict, setdefaultDistrict] = useState<
    ISampleLocTypeDistrictModel[]
  >([
    {
      response: "",
      label: "Not Applicable",
      code: "notApplicable",
      sampleCountry: "",
      sampleLocationType: 0,
      sampleLocID: "",
    },
  ]);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchInd, setSearchInd] = useState(-1);
  const [btnNameForLoader, setBtnNameForLoader] = useState<string>("");
  const [showSearchTestsModal, setShowSearchTestsModal] = useState(false);
  const [originalTestOptions, setOriginalTestOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [country, setCountry] = useState("");
  const [selectedTestIds, setSelectedTestIds] = useState<
    (number | undefined)[]
  >([]);
  const [nextClicked, setNextClicked] = useState(false);
  const [countriesList, setCountriesList] = useState<IcountryOptions[]>([]);
  const handleLoader = (enableLoader: boolean, btnNameOfLoader: string) => {
    setBtnNameForLoader(enableLoader ? btnNameOfLoader : "");
  };
  const [signOrSymptomsOptions, setsignOrSymptomsOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [sampleDescriptionOptionsBak, setSampleDescriptionOptionsBak] =
    useState<ISampleDescriptionModel[]>([]);
  const [severityOptions, setSeverityOptions] = useState<ISampleSeverity[]>([]);
  const [diseaseDistributionOptions, setdiseaseDistributionOptions] = useState<
    ISampleDiseaseDistribution[]
  >([]);
  const [selectedSampleLocation, setSelectedSampleLocation] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [checkpageLoader, setcheckPageLoader] = useState<boolean>(false);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const [modalLoader, setmodalLoader] = useState<boolean>(false);
  const [expandedSampleIndices, setExpandedSampleIndices] = useState<number[]>(
    []
  );
  const [selectedPackage, setSelectedPackage] = useState<string>("");
  const [testNames, setTestNames] = useState<string[]>([]);
  const [amendCase, setAmendCase] = useState<string>("");
  const [isCancelRequest, setIsCancelRequest] = useState<boolean>(false);
  const [IsAcknowledgeRequest, setIsAcknowledgeRequest] =
    useState<boolean>(false);
  const [districtOptionsBak, setDistrictOptionsBak] =
    useState<ISampleLocTypeDistrictModel[]>();
  const [countryOptionsBak, setCountryOptionsBak] = useState<ILabCountries[]>();
  const [showTooltip, setShowTooltip] = useState(false);
  const [checkedTests, setCheckedTests] = useState<{ [key: string]: boolean }>(
    {}
  );
  const reportTypeNames: { [key: number]: string } = {
    1: "Casesheet",
    2: "Laboratory Report",
    3: "Acknowledgment Slip",
    4: "Sample Label",
  };
  const [reports, setReports] = useState<
    {
      reportName: string;
      reportData: string;
      reportType: number;
      reportID: string;
      applicationId: string;
      isReportGenerated: any;
    }[]
  >([]);
  const renderReportType = (type: number) => {
    return reportTypeNames[type] || "Laboratory Report";
  };
  const handleCopyInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCopyCount(Number(event.target.value));
  };
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };
  const handleMouseLeave = () => {
    setShowTooltip(false);
  };
  const handleOptionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    if (
      selectedValue === "package" &&
      !visibleSampleDesc.includes(selectedSampleDesc[searchInd])
    ) {
      return;
    }

    setSelectionOption(selectedValue);
    setTestSelectionLimit(0);
  };
  useEffect(() => {
    const fetchTestPackages = async () => {
      try {
        setmodalLoader(true);
        const response: any = await getPSHPackages("");

        if (response && response.data) {
          const packageNames = response.data.map(
            (item: any) => item.packageName
          );

          const filteredPackages = packageNames.filter(
            (packageName: string) => {
              if (searchInd !== null) {
                const currentSampleDesc = selectedSampleDesc[searchInd];
                switch (currentSampleDesc) {
                  case "Soil":
                    return (
                      packageName === "Package A" ||
                      packageName === "Package B" ||
                      packageName === "Package C" ||
                      packageName === "Soil Texture - Test Group"
                    );

                  case "Approved Soil Mix":
                  case "Sand":
                  case "Soil Mix":
                    return (
                      packageName === "Package A" ||
                      packageName === "Package B" ||
                      packageName === "Package C" ||
                      packageName === "Particle Size- Test group"
                    );
                  case "Compost":
                    return packageName === "Particle Size- Test group";
                  default:
                    return false;
                }
              }
              return false;
            }
          );

          setPackages(filteredPackages);
        } else {
          console.error("Error: Response or response data is undefined.");
        }
      } catch (error) {
        console.error("Error fetching test packages:", error);
      } finally {
        setmodalLoader(false);
      }
    };

    fetchTestPackages();
  }, [selectedSampleDesc, searchInd]);
  const fetchTestOptions = async (
    selectedPackage: string,
    selectedSampleDesc: string
  ) => {
    try {
      const response = await getPSHPackages(selectedPackage);

      if (response && response.data) {
        const selectedPackageData = (response.data as any).find(
          (pkg: any) => pkg.packageName === selectedPackage
        );

        if (selectedPackageData) {
          const testsFromAPI =
            selectedPackageData.labTestPackagesGroupsCollections
              .filter(
                (test: any) => test.sampleDescriptionText === selectedSampleDesc
              )
              .map((test: any) => ({
                name: test.testName,
                testCodeText: test.testCodeText,
                testCodeID: test.testCodeID,
                sampleDescriptionText: test.sampleDescriptionText,
                isInitialSelected: test.required === 1,
                isSelected: test.required === 1,
              }));

          const testSelectionLimit = selectedPackageData.testSelectionLimit;
          setPackageDetails({
            id: selectedPackageData.id,
            name: selectedPackageData.packageName,
            testSelectionLimit,
          });
          setTestOptions(testsFromAPI);
          setTestSelectionLimit(testSelectionLimit);
          const initialSelectedState = testsFromAPI.some(
            (test: any) => test.isInitialSelected
          );
          setIsInitialSelected(initialSelectedState);
        } else {
          console.error("Selected package not found");
        }
      } else {
        console.error("Error: Response or response data is undefined.");
      }
    } catch (error) {
      console.error("Error fetching test options:", error);
    }
  };

  const toggleTestSelection = (
    testName: any,
    isChecked: boolean,
    isInitialSelected: boolean
  ) => {
    if (
      isChecked &&
      testSelectionLimit > 0 &&
      selectedTestIds.length >= testSelectionLimit
    ) {
      message(
        NotifyType.Error,
        `You can only select a maximum of ${testSelectionLimit} tests.`
      );
      return;
    }

    setSamples((prevSamples) => {
      return prevSamples.map((prevSample, index) => {
        if (index === searchInd) {
          const existingTestIds = (prevSample.labTestDetails || []).map(
            (existingTest: any) =>
              existingTest.testId || existingTest.testCodeID
          );

          const testToToggle = testOptions.find(
            (test) => test.name === testName
          );

          if (
            testToToggle &&
            existingTestIds.includes(testToToggle.testCodeID)
          ) {
            message(
              NotifyType.Error,
              "This test has already been added so cannot be added again."
            );
            return prevSample;
          }

          return {
            ...prevSample,
            labTestDetails: prevSample.labTestDetails.map((test) =>
              test.name === testName ? { ...test, isSelected: isChecked } : test
            ),
          };
        } else {
          return prevSample;
        }
      });
    });

    setTestOptions((prevOptions) =>
      prevOptions.map((test) =>
        test.name === testName ? { ...test, isSelected: isChecked } : test
      )
    );

    setSelectedTestIds((prevSelected) => {
      if (isChecked) {
        return [...prevSelected, testName];
      } else {
        return prevSelected.filter((name) => name !== testName);
      }
    });
  };

  const handleAddTests = () => {
    if (
      selectionOption === "package" &&
      selectedTestIds.length < testSelectionLimit
    ) {
      message(
        NotifyType.Error,
        `Please select at least ${testSelectionLimit} tests to proceed.`
      );
      return;
    }

    const testsToAdd = testOptions.filter((test: any) => test?.isSelected);
    const isManganeseSelected = testsToAdd.some(
      (test) => test.name.toLowerCase() === "manganese"
    );

    setSamples((prevSamples) => {
      return prevSamples.map((prevSample, index) => {
        if (index === searchInd) {
          const existingTestIds = (prevSample.labTestDetails || []).map(
            (existingTest: any) =>
              existingTest.testId || existingTest.testCodeID
          );
          if (isManganeseSelected) {
            const isPHAlreadyAdded = existingTestIds.some((testId) =>
              testOptions.find(
                (test) =>
                  test.name.toLowerCase() === "ph" && test.testCodeID === testId
              )
            );

            if (!isPHAlreadyAdded) {
              const phTestOption = testOptions.find(
                (test) => test.name.toLowerCase() === "ph"
              );

              if (phTestOption) {
                if (
                  !testsToAdd.some(
                    (test) => test.testCodeID === phTestOption.testCodeID
                  )
                ) {
                  testsToAdd.push(phTestOption);
                  message(
                    NotifyType.Info,
                    "pH test will also be included when Manganese is selected for lab to make correct interpretation of the Manganese test"
                  );
                }
              }
            }
          }
          const uniqueTestsToAdd = testsToAdd.filter(
            (test) => !existingTestIds.includes(test.testCodeID)
          );

          if (uniqueTestsToAdd.length === 0) {
            message(
              NotifyType.Error,
              "The selected tests have already been added."
            );
            return prevSample;
          }
          const currentTestDetails = [
            ...(prevSample.labTestDetails || []),
            ...uniqueTestsToAdd.map((test) => ({
              testId: test.testCodeID,
              testDescription: test.name,
              testCodeText: test.testCodeText,
              isSelected: true,
              packageName:
                selectionOption === "package" ? selectedPackage : null,
              packageId:
                selectionOption === "package" ? packageDetails.id : null,
            })),
          ];

          return { ...prevSample, labTestDetails: currentTestDetails };
        } else {
          return prevSample;
        }
      });
    });
    setTestOptions((prevOptions) => {
      const updatedOptions = prevOptions.filter(
        (test: any) => !selectedTestIds.includes(test.testCodeID)
      );

      return updatedOptions;
    });

    setSelectedTestIds([]);
    setSelectionOption("");
  };

  const handleSearch = async () => {
    try {
      handleLoader(true, "submit-reqq");
      const selectedSampleTypeForModal = selectedSampleType[searchInd];
      const selectedSampleDescForModal = selectedSampleDesc[searchInd];

      if (selectionOption === "individualTest") {
        await fetchTestCodeMaster(
          selectedSampleTypeForModal,
          selectedSampleDescForModal
        );
      } else if (selectionOption === "package") {
        if (!selectedPackage) {
          console.error("Error: No package selected");
          return;
        }
        await fetchTestOptions(selectedPackage, selectedSampleDescForModal);
      } else {
        console.error("Error: Invalid selection option");
      }
    } catch (error) {
      console.error("Error fetching test options:", error);
    } finally {
      handleLoader(false, "submit-reqq");
    }
  };

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSearch();
  };
  const handlePackageSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedPackageName = event.target.value;
    setSelectedPackage(selectedPackageName);

    const selectedPackageData = packages.find(
      (pkg: any) => pkg.packageName === selectedPackageName
    );

    const selectedPackageTestNames = selectedPackageData
      ? Array.isArray(selectedPackageData.labTestPackagesGroupsCollections)
        ? selectedPackageData.labTestPackagesGroupsCollections.map(
            (test: any) => test.testName
          )
        : []
      : [];
    setTestNames(selectedPackageTestNames);
  };
  const currentDate = new Date();
  const maxDateTime = currentDate.toISOString().split(".")[0];

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files) {
      let file = event.target.files[0];
      const getBase64 = await fileToBase64(file);
      if (getBase64.length) {
        setProjectDetails((prevState) => {
          return {
            ...prevState,
            "attachment": getBase64,
            "attachmentName": file?.name,
          } as IProjectDetails;
        });
      }
    }
  };

  const handleDistrictChange = (
    selectedOption: SingleValue<ISampleLocTypeDistrictModel>
  ) => {
    if (selectedOption) {
      const selectedDistrict = selectedOption.label;
      setDistrict(selectedDistrict);

      if (districtOptions) {
        const filtered = districtOptions.filter((option) =>
          option.code.toLowerCase().includes(selectedDistrict.toLowerCase())
        );

        setFilteredDistricts(filtered);
        setShowDistrictOptions(selectedDistrict.length > 0);
      }
    }
  };
  const handleDistrictSelect = (selectedDistrict: string) => {
    setDistrict(selectedDistrict);
    setShowDistrictOptions(false);
  };

  {
    showDistrictOptions && (
      <ul>
        {filteredDistricts.map((option, index) => (
          <li key={index} onClick={() => handleDistrictSelect(option.code)}>
            {option.code}
          </li>
        ))}
        {filteredDistricts.length === 0 && (
          <li onClick={() => handleDistrictSelect("Not Applicable")}>
            Not Applicable
          </li>
        )}
      </ul>
    );
  }

  const handleSampleLocationChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedLocation = e.target.value;
    setSampleLocation(selectedLocation);
    if (selectedLocation === "1") {
      setCountry("Singapore");
      setDistrict("");
      const event = {
        target: { value: "Singapore" },
      } as React.ChangeEvent<HTMLSelectElement>;

      handleCountryChange(event);
    } else {
      setCountry("");
      setSelectedDistrict("Not Applicable");
      setdistrictOptions(defaultDistrict);
      setDistrict("Not Applicable");
      handleDistrictSelect("Not Applicable");
    }
  };
  useEffect(() => {
    if (country) {
      const countrySelected = document
        .querySelector(`#country option[value="${country}"]`)
        ?.getAttribute("data-guid");

      if (countrySelected) {
        const filteredDistrict =
          districtOptionsBak?.filter(
            (x) => x.sampleCountry === countrySelected
          ) || [];
        setdistrictOptions(filteredDistrict);
      } else {
        setdistrictOptions([]);
      }
    } else {
      setdistrictOptions([]);
    }
  }, [country, sampleLocation]);

  const handleShowSearchTestsModal = (index: number) => {
    setSearchInd(index);
    setShowSearchTestsModal(true);
  };
  const handleCloseSearchTestsModal = () => {
    setTestDescription("");
    setSearchTerm("");
    setSelectionOption("");
    setTestOptions(originalTestOptions);
    setShowSearchTestsModal(false);
  };
  const handleShowDistrictSearchModal = (index: number) => {
    setSearchInd(index);
    setShowDistrictSearchModal(true);
  };
  const handleCloseDistrictSearchModal = () =>
    setShowDistrictSearchModal(false);

  let bannerName = "Application for Laboratory Testing";
  if (isCancelRequest) {
    bannerName = "Submission of Cancellation Request";
  } else if (amendCase) {
    bannerName = "Submission of Amendment Request";
  }

  let sampleSchema: SampleData = {
    id: Date.now(),
    marking: "",
    sampleType: "",
    sampleTypeText: "",
    sampleDescText: "",
    sampleNameText: "",
    signsOrSymptoms: [],
    diseaseDistribution: "",
    severity: 0,
    sampleDesc: "",
    scientificName: "",
    sampleLocation: "",
    signsOrSymptomsText: "",
    country: "",
    district: "",
    samplingDate: null,
    latitude: "",
    longitude: "",
    descriptionOptions: [],
    scientificNameOptions: [],
    sampleName: "",
    labTestDetails: [],
  };

  let projectDetailsSchema: IProjectDetails = {
    projectName: "",
    specialInstruction: "",
    otherRemarks: "",
    attachment: "",
    attachmentName: "",
    showProjectInput: "No",
  };

  const stepWizardConfig: IStepwizardProps = {
    currentStep: 2,
    steps: [
      {
        name: "Choose Application",
      },
      {
        name: "Samples & Tests",
      },
      {
        name: "Review",
      },
      {
        name: "Cost & Confirm",
      },
      {
        name: "Acknowledgement",
      },
    ],
  };

  const [samples, setSamples] = useState<SampleData[]>([...[sampleSchema]]);
  const [projectDetails, setProjectDetails] =
    useState<IProjectDetails>(projectDetailsSchema);

  const sampleLocationMapping: { [key: string]: string } = {
    "1": "Local",
    "2": "Foreign",
  };

  const handlePreviousClick = () => {
    storeInLocalStorage();

    if (IsAcknowledgeRequest || isCancelRequest || amendCase) {
      navigate("/lab-dashboard");
    } else {
      navigate("/choose-application");
    }
  };

  const handleAddSample = () => {
    setSamples((prevSamples) => {
      const newSample = { ...sampleSchema, id: Date.now(), labTestDetails: [] };
      return [...prevSamples, newSample];
    });
  };

  const handleCopySample = (sampleInd: number, times: number) => {
    const sample = samples[sampleInd];

    setSamples((prevSamples) => {
      const newSamples = [
        ...prevSamples,
        ...Array.from({ length: times }, () => {
          const newSample = {
            ...sample,
            id: Date.now() + Math.random(),
            disableDelete: false,
            labTestDetails: sample?.labTestDetails?.map((obj) => ({
              ...obj,
              disableDelete: false,
            })),
          } as any;
          if (newSample.hasOwnProperty("marking")) {
            delete newSample.marking;
          }
          if (newSample.hasOwnProperty("rowId")) {
            delete newSample.rowId;
          }
          return newSample;
        }),
      ];
      return newSamples;
    });

    setDescriptionOptions((prevOptions) => {
      const newOptions = [...prevOptions];
      const originalOption = Array.isArray(newOptions[sampleInd])
        ? newOptions[sampleInd]
        : [];

      for (let i = 0; i < times; i++) {
        newOptions.push([...originalOption]);
      }
      return newOptions;
    });
    setSelectedSampleDesc((prevDesc) => [
      ...prevDesc,
      ...Array.from({ length: times }, () => sample.sampleDesc),
    ]);

    setSelectedSampleType((prevType) => [
      ...prevType,
      ...Array.from({ length: times }, () => sample.sampleType),
    ]);
  };

  const handleDeleteSample = (sampleId: number | undefined) => {
    setSamples((samples) => {
      if (samples.length > 1) {
        return samples.filter((sample) => sample.id !== sampleId);
      }
      return samples;
    });
  };

  interface CustomInputProps {
    value: string;
    onClick: () => void;
  }

  const handleCountryChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    let countrySelected = document
      .querySelector(`#country option[value="${e.target.value}"]`)
      ?.getAttribute("data-guid");

    if (countrySelected) {
      let filteredDistrict =
        districtOptionsBak?.filter(
          (x) => x.sampleCountry === countrySelected
        ) || [];

      setdistrictOptions(filteredDistrict);
      return;
    }

    setdistrictOptions([]);
  };
  useEffect(() => {
    if (searchInd !== null) {
      const currentSampleDesc = selectedSampleDesc[searchInd];

      if (currentSampleDesc && !visibleSampleDesc.includes(currentSampleDesc)) {
        setSelectionOption((prev) => (prev === "" ? "individualTest" : prev));
      } else if (
        currentSampleDesc &&
        visibleSampleDesc.includes(currentSampleDesc)
      ) {
        setSelectionOption((prev) => (prev === "" ? "individualTest" : prev));
      }
    }
  }, [selectedSampleDesc, visibleSampleDesc, searchInd]);

  const handleDownload = (fileName: string, reportData: string) => {
    try {
      const decodedData = atob(reportData);
      const byteCharacters = Array.from(decodedData).map((char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteCharacters);

      const blob = new Blob([byteArray], { type: "application/pdf" });

      FileSaver.saveAs(blob, fileName);
      window.location.href = `/eservices/rating-feedback?an=${applicationNum}`;
    } catch (error) {
      console.error(error);
      message(NotifyType.Info, "Error downloading the file");
    }
  };

  type FormChangeEvent =
    | React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    | { name: string; value: any }
    | { target: { name: string; value: any } };
  const handleFormChange =
    (index: number, type: string) => (e: FormChangeEvent) => {
      const newArray = samples.map((item: SampleData, i) => {
        if (index === i) {
          let newValue: any;
          let name: string;

          if ("target" in e) {
            newValue = e.target.value;
            name = e.target.name;
          } else {
            newValue = e.value;
            name = e.name;
          }

          if (type === "number") {
            newValue = parseInt(newValue);
          } else if (type === "date" || type === "datetime-local") {
            newValue = moment(newValue).format("DD/MM/YYYY hh:mm A");
          }

          let newLabTestDetails = item.labTestDetails;
          if (name === "sampleDesc" && newValue !== item.sampleDesc) {
            newLabTestDetails = [];
          }

          let scientificName = item.scientificName;
          let sampleName = item.sampleName;
          if (name === "scientificName") {
            const selectedScientificName = newValue;

            if (
              item.sampleNameOptions &&
              Array.isArray(item.sampleNameOptions)
            ) {
              const foundOption = item.sampleNameOptions.find(
                (option: any) =>
                  option.scientificName === selectedScientificName
              );
              sampleName = foundOption ? foundOption.name : "";
            }
          }
          if (name === "sampleName") {
            const selectedSampleName = newValue;

            if (
              item.sampleNameOptions &&
              Array.isArray(item.sampleNameOptions)
            ) {
              const foundOption = item.sampleNameOptions.find(
                (option: any) => option.name === selectedSampleName
              );
              scientificName = foundOption ? foundOption.scientificName : "";
            }
          }

          const updatedItem = {
            ...item,
            [name]: newValue,
            sampleName:
              name === "scientificName"
                ? sampleName
                : name === "sampleName"
                ? newValue
                : item.sampleName,
            scientificName:
              name === "sampleName"
                ? scientificName
                : name === "scientificName"
                ? newValue
                : item.scientificName,
            labTestDetails: newLabTestDetails,
          };

          if (name === "sampleDesc") {
            setSelectedSampleDesc((prevDesc) => {
              const updatedDesc = [...prevDesc];
              updatedDesc[index] = newValue;
              return updatedDesc;
            });
          }

          return updatedItem;
        }
        return item;
      });

      setTestDescription("");
      setSamples(newArray);
    };

  const handleMyPreference = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, type, value } = e.target;
    const isCheckbox = type === "checkbox";
    const inputValue = isCheckbox
      ? (e.target as HTMLInputElement).checked
      : value;

    setProjectDetails((prevState) => ({
      ...prevState,
      [name]: inputValue,
    }));
  };

  const handleContentToggle = (index: number) => {
    setExpandedSampleIndices((prevIndices) =>
      prevIndices.includes(index)
        ? prevIndices.filter((i) => i !== index)
        : [...prevIndices, index]
    );
  };
  const handleSampleTypeChange = (
    index: number,
    selectedOption: { value: string; label: string; id?: string }
  ) => {
    let nameDescOptions: any = { name: [], desc: [] };

    if (selectedOption) {
      const { value, id } = selectedOption;

      nameDescOptions = handleSampleNameAndDesc(id || "", "guid", index);

      fetchSampleDescriptions(value, index);
    }

    const newArray = samples.map((item: SampleData, i) => {
      if (index === i) {
        return {
          ...item,
          sampleType: selectedOption.value,
          sampleNameOptions: nameDescOptions.name,
          scientificNameOptions: nameDescOptions.scientificName,
          sampleDesOptions: nameDescOptions.desc,
          sampleDesc: "",
          sampleName: "",
          scientificName: "",
          labTestDetails: [],
        };
      } else {
        return item;
      }
    });

    setSamples(newArray);
    setSelectedSampleType(newArray.map((sample) => sample.sampleType));
  };

  const handleFormChangeCustom = (index: number, obj: any) => {
    const newArray = samples.map((item: SampleData, i) => {
      if (index === i) {
        return { ...item, ...obj };
      } else {
        return item;
      }
    });
    setSamples(newArray);
  };
  useEffect(() => {
    samples.forEach((sample, index) => {
      if (sample.sampleType) {
        fetchSampleDescriptions(sample.sampleType, index);
      }
    });
  }, [samples]);

  const handleNextClick = () => {
    handleLoader(true, "next-click");
    localStorage.removeItem("ismetadata");
    storeInLocalStorage();
    setSamples([sampleSchema]);
    handleLoader(false, "next-click");
    navigate("/review");
  };

  useEffect(() => {
    const fetchData = () => {
      const samplesData = localStorage.getItem("sample-data");
      if (samplesData) {
        const parsedSamples = JSON.parse(samplesData);
        setSamples(parsedSamples);
        const sampleTypes = parsedSamples.map(
          (sample: any) => sample.sampleType
        );
        const sampleDescs = parsedSamples.map(
          (sample: any) => sample.sampleDesc
        );

        setSelectedSampleType(sampleTypes);
        setSelectedSampleDesc(sampleDescs);

        parsedSamples.forEach((sample: any, index: number) => {
          if (searchInd === index) {
            if (visibleSampleDesc.includes(sample.sampleDesc)) {
              setSelectionOption("package");
            } else {
              setSelectionOption("individualTest");
            }
          }
        });

        localStorage.removeItem("sample-data");
      }

      const projectDetailsData = localStorage.getItem("lab-project-details");
      if (projectDetailsData) {
        setProjectDetails(JSON.parse(projectDetailsData));
        localStorage.removeItem("lab-project-details");
      }
    };

    if (location.state && location.state.shouldFetchData) {
      fetchData();
    }
  }, [location.state, searchInd, visibleSampleDesc]);

  useEffect(() => {
    btnLoaderHandler(btnNameForLoader ? true : false);
  }, [btnNameForLoader]);

  const storeInLocalStorage = () => {
    const maxSampleRowId = samples.reduce((maxId, sample) => {
      const rowId = typeof sample.rowId === "number" ? sample.rowId : 0;
      return Math.max(maxId, rowId);
    }, 0);
    let sampleRowId = 1;
    const updatedSamples = samples.map((sample) => {
      let testRowId = 1;
      const updatedSample = {
        ...sample,
        rowId: sampleRowId,
        sampleRowId: sampleRowId++,
        labTestDetails: sample.labTestDetails?.map((test) => ({
          ...test,
          rowId: testRowId,
          testRowId: testRowId++,
        })),
      };

      return updatedSample;
    });

    localStorage.setItem("sample-data", JSON.stringify(updatedSamples));
    localStorage.setItem("lab-project-details", JSON.stringify(projectDetails));

    if (actionType) localStorage.setItem("psh-action-type", actionType);
    if (applicationNum)
      localStorage.setItem("psh-application-no", applicationNum);
  };

  const CustomInput: React.FC<CustomInputProps> = ({ value, onClick }) => (
    <div className="input-group">
      <input
        type="text"
        className="form-control"
        value={value}
        onClick={onClick}
        readOnly
      />
      <div className="input-group-append">
        <span className="input-group-text">
          <FontAwesomeIcon icon={faCalendarAlt} onClick={onClick} />
        </span>
      </div>
    </div>
  );
  const handleCopyButtonClick = (index: number) => {
    handleCopySample(index, copyCount || 1);
  };
  const fetchTestCodeMaster = async (
    selectedSampleType: string,
    selectedSampleDesc: string
  ) => {
    try {
      const response = await getPSHIndividualTests(
        selectedSampleType,
        selectedSampleDesc
      );

      if (response && response.data && Array.isArray(response.data)) {
        const dataArray = response.data;
        const searchString = (testDescription || "").toLowerCase();

        const filteredArray = dataArray.filter((item: any) =>
          item.name
            ? item.name.toLowerCase().includes(searchString.toLowerCase())
            : false
        );

        const testOptions = filteredArray.map((item) => ({
          id: item.id,
          testCodeID: item.labCodeMasterID,
          test: item.test,
          testCodeText: item.name,
          title: item.title,
          name: item.name,
          isSelected: false,
        }));

        setTestOptions(testOptions as any[]);
      } else {
        const errorMessage =
          "No Tests found for the selected sample type and description.";
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      console.error("Error fetching test code master data:", error);
    }
  };

  const [selectedOptions, setSelectedOptions] = useState(null);
  const handleSelect = (selectedOptions: any, index: number) => {
    setSelectedOptions(selectedOptions);

    const signsOrSymptomsValue = selectedOptions.map(
      (option: any) => option.value
    );

    setSamples((prevSamples: any) => {
      return prevSamples.map((prevSample: any, i: number) => {
        if (i === index) {
          return {
            ...prevSample,
            signsOrSymptoms: signsOrSymptomsValue,
          };
        }
        return prevSample;
      });
    });
  };

  const handleRemoveTest = (
    labDetails: ILabTestDetails[],
    description: string,
    ind: number
  ) => {
    const packageToRemove = labDetails.find(
      (test: ILabTestDetails) => test.testDescription === description
    )?.packageName;
    let removeTheLabID: ILabTestDetails[];

    if (packageToRemove) {
      removeTheLabID = labDetails.filter(
        (test: ILabTestDetails) => test.packageName !== packageToRemove
      );
    } else {
      removeTheLabID = labDetails.filter(
        (test: ILabTestDetails) => test.testDescription !== description
      );
    }
    const newArray = samples.map((item: SampleData, i) => {
      if (ind === i) {
        return { ...item, labTestDetails: removeTheLabID };
      } else {
        return item;
      }
    });

    setSamples(newArray);
  };
  const handleModalSearch = () => {
    setSelectedSampleLocation(sampleLocation);
    if (!sampleLocation) {
      setLocationError("Please select a location.");
      return;
    }
    if (!country) {
      setcountryError("Please select a country.");
      return;
    }
    setcountryError(null);
    setLocationError(null);
    if ((sampleLocation === "1" || sampleLocation === "2") && !district) {
      setDistrictError("Please select a district.");
      return;
    }
    setDistrictError(null);

    let obj: any = {
      district: district,
      country: country,
      sampleLocation: sampleLocation,
    };
    handleFormChangeCustom(searchInd, obj);

    const sampleLocationName = sampleLocationMapping[sampleLocation];
    if (sampleLocationName) {
      setSelectedSampleLocation(sampleLocationName);
    } else {
      console.error("No sample location found with value:", sampleLocation);
    }

    setSelectedDistrict(district);

    setSelectedCountry(country);

    handleCloseDistrictSearchModal();
  };

  useEffect(() => {
    fetchMasters();
  }, []);

  const fetchMasters = async () => {
    try {
      setPageLoader(true);

      const response = await getLabMaster();
      let masters = response.data.masters;
      if (response?.status == 200) {
        setSampleTypeOptions(masters.sampleTypes);
        if (masters?.signOrSymptoms?.length) {
          let signsOptions: IReactSelectOption[] = masters.signOrSymptoms.map(
            (x) => {
              return {
                label: x.name,
                value: x.name,
              };
            }
          );
          setsignOrSymptomsOptions(signsOptions);
        }
        if (masters.severity) {
          let severity = masters.severity;
          let values: number[] = Object.values(severity);
          let severityArr: ISampleSeverity[] = Object.keys(severity).map(
            (x, ind) => {
              return {
                id: values[ind],
                name: x,
              };
            }
          );
          setSeverityOptions(severityArr);
        }
        setdiseaseDistributionOptions(masters.diseaseDistribution);

        const fetchSampleNames = async () => {
          const response = await getSampleNames();
          setSampleNameOptionsBak(response.data);
        };

        await fetchSampleNames();

        const response = await getSampleLocTypeDist();

        const countries = await getLabCountries();
        setDistrictOptionsBak(response.data);
        setCountryOptionsBak(countries.data);
      }
      if (inputCountryRef.current) {
        inputCountryRef.current = false;
        const fetchData = async () => {
          const countries = await fetchCountryOptions();
          setCountriesList(countries);
        };
        fetchData();
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setPageLoader(false);
    }
  };

  const fetchSampleDescriptions = async (sampleType: string, index: number) => {
    try {
      const response = await getSampleDescriptionbyType(sampleType);
      const sampleDescriptions = response.data.map((item) => item.name);
      setDescriptionOptions((prevOptions: any) => {
        const newOptions = [...prevOptions];
        newOptions[index] = sampleDescriptions;
        return newOptions;
      });
    } catch (error) {
      console.error(error);
    }
  };

  const validateForm = () => {
    let isValid = true;
    const manFields = Object.values(mandatoryFields);
    const sampleMarkingsAll = samples
      .map((s: any) => s.marking?.trim())
      .filter(Boolean);
    const duplicates = sampleMarkingsAll.filter(
      (mark, idx, arr) =>
        arr.indexOf(mark) !== idx && arr.lastIndexOf(mark) === idx
    );
    const newArray = samples.map((item: any) => {
      manFields.forEach((x: any) => {
        const temp = item[x];
        if (typeof temp === "number") {
          if (!temp) {
            isValid = false;
            item = { ...item, [`${x}ErrMsg`]: `Please fill ${x}.` };
          } else {
            item = { ...item, [`${x}ErrMsg`]: `` };
          }
        } else {
          if (!temp?.length) {
            isValid = false;
            item = { ...item, [`${x}ErrMsg`]: `Please fill ${x}.` };
          } else {
            item = { ...item, [`${x}ErrMsg`]: `` };
          }
        }
      });
      const trimmedMark = item.marking?.trim();
      if (!trimmedMark) {
        isValid = false;
        item = { ...item, markingErrMsg: "Please fill Sampling Marking" };
      } else if (duplicates.includes(trimmedMark)) {
        isValid = false;
        item = {
          ...item,
          markingErrMsg: "Sample Marking must be unique across all samples.",
        };
      } else {
        item = { ...item, markingErrMsg: "" };
      }
      return item;
    });

    setSamples(newArray);

    if (!isValid) {
      message(NotifyType.Error, "Please fill the mandatory fields.");
      return;
    }

    if (
      projectDetails.showProjectInput === "Yes" &&
      !projectDetails.projectName?.trim()
    ) {
      message(NotifyType.Error, "Please fill the mandatory fields.");
      setProjectDetails((prevState) => ({
        ...prevState,
        projectNameErrMsg: "Please Enter Project Name/Location.",
      }));
      setNextClicked(true);
      return;
    } else {
      setProjectDetails((prevState) => ({
        ...prevState,
        projectNameErrMsg: "",
      }));
    }

    let personalInfo: IPersonalInfo = JSON.parse(
      localStorage.getItem("profile-info") || ""
    );

    if (!personalInfo?.address?.streetName?.trim()) {
      setNextClicked(true);
      message(
        NotifyType.Error,
        "Please fill the mailing address street name fields."
      );
      return;
    }

    if (!personalInfo?.address?.postalCode) {
      setNextClicked(true);
      message(
        NotifyType.Error,
        "Please fill the mailing address postal code fields."
      );
      return;
    }

    if (!personalInfo?.contact?.salutation) {
      setNextClicked(true);
      message(NotifyType.Error, "Please fill Salutation.");
      return;
    }

    if (!personalInfo?.contact?.email) {
      setNextClicked(true);
      message(NotifyType.Error, "Please fill Email.");
      return;
    }

    handleNextClick();
  };

  useEffect(() => {
    async function checkQueryString() {
      try {
        setcheckPageLoader(true);
        const applicationNum: string | null = params.get("an");
        const getUserInfo = localStorage.getItem("app-data");
        const userInfo = JSON.parse(getUserInfo || "");
        let NRIC = userInfo?.user?.idNo || "";
        const actionType: string | null = params.get("type");
        setActionType(actionType || "");
        setApplicationNum(applicationNum || "");
        let isNricRequired = 1;

        if (applicationNum && actionType) {
          const getPsh = await getPSHApplication(
            applicationNum,
            NRIC,
            isNricRequired
          );
          if (getPsh.status === 200) {
            let result = getPsh.data.result;
            const feedback = result?.submittedFeedback || 0;
            const reportgenerated = result?.isReportGenerated || 0;
            const reports = Array.isArray(result?.labReportDetails)
              ? result.labReportDetails
              : [];
            setReports(reports);
            setreportgenerated(reportgenerated);
            setSubmittedFeedback(feedback);
            const personalInfoDetails = result?.labPSHPersonalInfoDetails;
            if (result?.labPSHSampleTests?.length > 0) {
              localStorage.setItem(
                "choose-app",
                JSON.stringify(result.labPSHChooseApplDetails)
              );
              const actionedStatus = result?.actionStatus;
              if (actionedStatus) {
                localStorage.setItem("psh-app-status", actionedStatus);
              }
              if (
                actionType == TypeOfApplicationEnum.amendment &&
                result?.actionStatus
              ) {
                let amendCase = "";

                if (result.actionStatus === "Pending Sample(s)") {
                  amendCase = "CASE1";
                } else {
                  amendCase = "CASE3";
                }

                setAmendCase(amendCase);
              } else if (actionType === TypeOfApplicationEnum.cancel) {
                setIsCancelRequest(true);
              } else if (actionType === TypeOfApplicationEnum.acknowledgement) {
                setIsAcknowledgeRequest(true);
              }

              let samplesAndTests = result.labPSHSampleTests;

              const updatedSamples = await Promise.all(
                samplesAndTests.map(async (sample, index) => {
                  const nameDescOptions = await getSampleNamesbyType(
                    sample.sampleType
                  );

                  return {
                    ...sample,
                    id: sample.id || index + 1,

                    sampleNameOptions: nameDescOptions.data,
                    scientificNameOptions: nameDescOptions.data.map(
                      (option: any) => option.scientificName
                    ),
                    disableDelete: true,
                    labTestDetails: sample.labTestDetails.map((obj: any) => ({
                      ...obj,

                      disableDelete: true,
                      testCodeID: obj.testCodeId,
                      testCodeText: obj.testCodeText,
                      packageName: obj.packageName,
                      packageCode: obj.packageName,
                    })),
                    sampleLocation:
                      Object.keys(sampleLocationMapping).find(
                        (key) =>
                          sampleLocationMapping[key] === sample.sampleLocation
                      ) || "",
                  };
                })
              );

              setSamples(updatedSamples);
              const sampleTypes = updatedSamples.map(
                (sample: any) => sample.sampleType
              );
              const sampleDescs = updatedSamples.map(
                (sample: any) => sample.sampleDesc
              );
              setSelectedSampleType(sampleTypes);
              setSelectedSampleDesc(sampleDescs);
              if (updatedSamples.length > 0) {
                const currentSampleDesc = updatedSamples[searchInd]?.sampleDesc;

                if (
                  currentSampleDesc &&
                  !visibleSampleDesc.includes(currentSampleDesc)
                ) {
                  setSelectionOption((prev) =>
                    prev === "" ? "individualTest" : prev
                  );
                } else if (
                  currentSampleDesc &&
                  visibleSampleDesc.includes(currentSampleDesc)
                ) {
                  setSelectionOption("individualTest");
                }
              }

              setProjectDetails({
                ...result?.labPSHPreference,
              });
            }
            setPersonalInfo(personalInfoDetails);
          }
        }
      } catch (error) {
        console.error(ErrMsg.InternalServerErrMsg, error);
        message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
      } finally {
        setcheckPageLoader(false);
      }
    }
    if (!hasFetchedInitialData) {
      checkQueryString();
      setHasFetchedInitialData(true);
    }
  }, [sampleDescriptionOptionsBak]);

  const handleSampleNameAndDesc = (
    sampleType: string,
    type: string,
    index: number
  ) => {
    let sampleTypeId = sampleType;
    if (type === "string") {
      const sampleTypeArr = sampletypeOptions.filter(
        (x) => x.name === sampleType
      );
      sampleTypeId = sampleTypeArr.length ? sampleTypeArr[0].id : sampleType;
    }

    const sampleNameOptions = samplenameOptionsBak.filter(
      (x) => x.sampleTypes === sampleTypeId
    );
    const scientificNameOptions = sampleNameOptions.map(
      (x) => x.scientificName
    );
    const sampleDesOptions = descriptionOptions[index] || [];

    const updatedNameDescOptions = {
      name: sampleNameOptions,
      scientificName: scientificNameOptions,
      desc: sampleDesOptions,
    };

    setSamples((prevSamples) => {
      const updatedSamples = [...prevSamples];
      updatedSamples[index] = {
        ...updatedSamples[index],
        sampleNameOptions: sampleNameOptions,
        scientificNameOptions: scientificNameOptions,
        descriptionOptions: sampleDesOptions,
      };
      return updatedSamples;
    });

    return updatedNameDescOptions;
  };

  const handleSaveDraftClick = async () => {
    try {
      handleLoader(true, "submit-req");
      samples.forEach(function (v) {
        delete v?.id;
        delete v.sampleNameOptions;
        delete v.sampleDesOptions;
        delete v?.descriptionOptions;
        delete v?.scientificNameOptions;
        delete v?.markingErrMsg;
        delete v?.countryErrMsg;
        delete v?.markingErrMsg;
        delete v?.sampleTypeErrMsg;
        delete v?.signsOrSymptomsErrMsg;
        delete v?.diseaseDistributionErrMsg;
        delete v?.severityErrMsg;
        delete v?.sampleDescErrMsg;
        delete v?.sampleLocationErrMsg;
        delete v?.countryErrMsg;
        delete v?.districtErrMsg;
        delete v?.samplingDateErrMsg;
        delete v?.sampleNameErrMsg;
        delete v?.labTestDetailsErrMsg;
        delete v?.disableDelete;
        v?.labTestDetails?.forEach((element) => {
          delete element?.disableDelete;
        });
      });
      const hasEmptyTests = samples.some(
        (sample) => !sample.labTestDetails || sample.labTestDetails.length === 0
      );

      if (hasEmptyTests) {
        message(NotifyType.Error, "Please add Test Information.");
        handleLoader(false, "submit-req");
        return;
      }
      let labApplicationDetails: any = Object.create({});
      let chooseApp: string | null = localStorage.getItem("choose-app");
      let chooseAppMeta: IChooseApp = {
        typeOfApplication: "COM",
        typeOfService: "Plant Health Diagnostics Services",
        applicationType: 0
      };

      if (chooseApp && chooseApp.length) {
        let parsedChooseApp: IChooseApp = JSON.parse(chooseApp);
        chooseAppMeta = {
          ...chooseAppMeta,
          ...parsedChooseApp,
          typeOfApplication: "COM",
        };
      }
      let personalInfo: IPersonalInfo = JSON.parse(
        localStorage.getItem("profile-info") || ""
      );
      let sampleData: string | null = localStorage.getItem("sample-data");
      let sampleDataMeta: SampleData[] = [];

      if (sampleData?.length) {
        sampleDataMeta = JSON.parse(sampleData);
      }

      labApplicationDetails = { ...labApplicationDetails, ...personalInfo };
      let applicationNumFromLocal = localStorage.getItem("psh-application-no");
      const filerInfo: IFilerInformation | null = getFilerInfomation();
      const meta: ILabSampleModelRequest = {
        labPSHChooseApplDetails: chooseAppMeta,
        applicationNumber: applicationNum || applicationNumFromLocal || "",
        labPSHSampleTests: samples,
        labPSHPersonalInfoDetails: personalInfo,
        labPSHPreference: projectDetails,
        labPSHFilerInfoDetails: filerInfo || tempFilerInfo,
      };
      if (actionType === TypeOfApplicationEnum.submit) {
        delete meta.applicationNumber;
      }

      const response1 = await SavePSHDraftApplications(meta);

      if (response1.status === 200) {
        const responseData = JSON.parse(response1.data as any);
        const acknowledgmentNumber = responseData?.PSHDraftApplicationNumber;
        message(
          NotifyType.Success,
          acknowledgmentNumber
            ? `Draft Saved Successfully`
            : "Draft Saved Successfully"
        );
        setApplicationNum(acknowledgmentNumber || "");
        if (actionType === TypeOfApplicationEnum.submit) {
          setActionType("Draft");
        }
        setAcknowledgmentMessage(
          acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
        );
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
        handleLoader(false, "submit-req");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };

  const cancelRequest = async () => {
    try {
      setCancelCommentsErrMsg("");
      if (cancelComments) {
        handleLoader(true, "cancel-request-btn");
        samples.forEach(function (v) {
          delete v?.id;
          delete v.sampleNameOptions;
          delete v.sampleDesOptions;
          delete v?.scientificNameOptions;
          delete v?.markingErrMsg;
          delete v?.countryErrMsg;
          delete v?.markingErrMsg;
          delete v?.sampleTypeErrMsg;
          delete v?.signsOrSymptomsErrMsg;
          delete v?.diseaseDistributionErrMsg;
          delete v?.severityErrMsg;
          delete v?.sampleDescErrMsg;
          delete v?.sampleLocationErrMsg;
          delete v?.countryErrMsg;
          delete v?.districtErrMsg;
          delete v?.samplingDateErrMsg;
          delete v?.sampleNameErrMsg;
          delete v?.labTestDetailsErrMsg;
          delete v?.disableDelete;
          v?.labTestDetails?.forEach((element) => {
            delete element?.disableDelete;
          });
        });

        let chooseAppMeta: IChooseApp = JSON.parse(
          localStorage.getItem("choose-app") || ""
        );

        let personalInfo: IPersonalInfo = JSON.parse(
          localStorage.getItem("profile-info") || ""
        );
        const filerInfo: IFilerInformation | null = getFilerInfomation();

        const meta: ILabSampleModelRequest = {
          labPSHChooseApplDetails: chooseAppMeta,
          labPSHSampleTests: samples,
          labPSHPersonalInfoDetails: personalInfo,
          labPSHPreference: projectDetails,
          applicationNumber: applicationNum || "",
          reasonForCancellation: cancelComments,
          labPSHFilerInfoDetails: filerInfo || tempFilerInfo,
          labPSHApplicationStatus: defCancelAppStatus,
        };

        let response1 = await saveLabCancellation(meta);
        if (response1.status === 200) {
          const acknowledgmentNumberMatch = response1.data?.match(
            /"PSHCancelApplicationNumber":"(\w+)"/
          );

          const acknowledgmentNumber = acknowledgmentNumberMatch
            ? acknowledgmentNumberMatch[1]
            : undefined;
          message(
            NotifyType.Success,
            `Cancellation Request Submitted Successfully. Acknowledgment Number: ${acknowledgmentNumber}`
          );
          setcancelMessage(
            acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
          );

          localStorage.removeItem("choose-app");
          setCancelButtonHidden(true);
          setTimeout(() => {
            navigate("/lab-dashboard", { state: { acknowledgmentNumber } });
          }, 3000);
        } else {
          message(NotifyType.Error, "Issue on the request submission.");
        }
      } else {
        setCancelCommentsErrMsg("Please fill Cancellation Comments");
        message(NotifyType.Error, "Please fill the mandatory fields.");
      }
      handleLoader(false, "cancel-request-btn");
    } catch (ex) {
      console.error(ex);
      handleLoader(false, "cancel-request-btn");
    }
  };

  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab">{bannerName} </div>

        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />

        <div className="row setup-content" id="step-1">
          <div className="col-md-12">
            <div className="tab-wizard-content">
              {acknowledgmentMessage && (
                <div className="info-content">
                  <div className="att">
                    <h3>Attention</h3>
                    <br />
                    <p className="attention">
                      {">"} Application has been successfully Saved as Draft.
                      Service Acknowledgement Number: &nbsp;
                      {acknowledgmentNumber ? acknowledgmentNumber : ""}
                    </p>
                    {acknowledgmentMessage}
                  </div>
                </div>
              )}
              {cancelMessage && (
                <div className="info-content">
                  <div className="att">
                    <h3>Attention</h3>
                    <br />
                    <p className="attention">
                      {">"} Cancellation Request Submitted Successfully. Service
                      Acknowledgement Number: &nbsp;
                      {cancelMessage ? cancelMessage : ""}
                    </p>
                  </div>
                </div>
              )}
              {applicationNum && !cancelMessage && (
                <div className="info-content">
                  <div className="att">
                    <h2>
                      <center>Application Number: {applicationNum}</center>
                    </h2>
                  </div>
                </div>
              )}
              <PersonalInformation profileInfo={personalInfo} />

              {IsAcknowledgeRequest ? (
                <div className="personal-info">
                  <div className="clonable-block" data-toggle="cloner">
                    <div className="clonable" data-clone-number="1">
                      <div className="info-heading">
                        <table className="table table-bordered table-hover">
                          <thead>
                            <tr>
                              <th className="grid-header">Report Name</th>
                              <th className="grid-header">Report Type</th>
                              <th className="grid-header">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {reports
                              .filter((report) => {
                                const actionedStatus =
                                  localStorage.getItem("psh-app-status");
                                if (report.reportData === null) return false;
                                if (report.reportType === 5) {
                                  return (
                                    actionedStatus !== "Pending Sample(s)" &&
                                    actionedStatus !== "Sample(s) Received"
                                  );
                                }
                                return report.reportType === 3;
                              })
                              .map((report) => (
                                <tr key={report.reportName}>
                                  <td>
                                    <center>
                                      <h6>{report.reportName}</h6>
                                    </center>
                                  </td>
                                  <td>
                                    <h6>
                                      {renderReportType(report.reportType)}
                                    </h6>
                                  </td>
                                  <td>
                                    <button
                                      className="ACKFile"
                                      onClick={() =>
                                        handleDownload(
                                          report.reportName,
                                          report.reportData
                                        )
                                      }
                                    >
                                      Download
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              <Tabs
                className="samples-and-tests-cavs"
                defaultActiveKey={1}
                id="uncontrolled-tab-example"
              >
                <Tab eventKey={1} title="Sample Details">
                  {pageLoader || checkpageLoader ? (
                    <Loader />
                  ) : (
                    samples &&
                    samples.map((sample, index) => (
                      <div className="personal-info" key={sample.id}>
                        <div className="clonable-block" data-toggle="cloner">
                          <div className="clonable" data-clone-number="1">
                            <div className="info-heading">
                              {amendCase !== "CASE3" &&
                              amendCase !== "CASE4" &&
                              !isCancelRequest &&
                              !IsAcknowledgeRequest ? (
                                <ul className="card-icons float-end">
                                  <li>
                                    <button
                                      className="icon-button"
                                      title="New"
                                      onClick={handleAddSample}
                                    >
                                      <FontAwesomeIcon icon={faPlus} />
                                    </button>
                                  </li>

                                  <li className="copy-button-container">
                                    <button
                                      className="icon-button"
                                      title="Copy"
                                      onClick={() =>
                                        handleCopyButtonClick(index)
                                      }
                                    >
                                      <FontAwesomeIcon icon={faCopy} />
                                    </button>
                                    <input
                                      type="number"
                                      className="copy-input"
                                      min="1"
                                      value={copyCount}
                                      onChange={handleCopyInputChange}
                                    />
                                  </li>
                                  {!(
                                    amendCase == "CASE3" &&
                                    sample?.disableDelete
                                  ) ? (
                                    <li>
                                      <button
                                        className="icon-button"
                                        onClick={() =>
                                          handleDeleteSample(sample?.id)
                                        }
                                      >
                                        <FontAwesomeIcon icon={faTrashCan} />
                                      </button>
                                    </li>
                                  ) : (
                                    ""
                                  )}
                                </ul>
                              ) : (
                                ""
                              )}
                              <h2>{`Sample ${index + 1}`}</h2>
                              <br />

                              {amendCase === "CASE3" && (
                                <div className="text-danger">
                                  <center>
                                    {" "}
                                    Please be noted that the sample type, sample
                                    name, sample description, and test assigned
                                    are not allowed to be amended at this stage.
                                  </center>{" "}
                                </div>
                              )}
                            </div>
                            <div className="info-content">
                              <div className="table-responsive mt-2 mb-2 ">
                                <table className="table table-striped product_table start_table">
                                  <thead>
                                    <tr>
                                      <th className="w-34" colSpan={2}>
                                        Sample Type
                                        <span className="star-red">*</span>
                                      </th>
                                      <th className="w-34" colSpan={2}>
                                        Sample Name
                                        <span className="star-red">*</span>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td colSpan={2}>
                                        <Select
                                          name="sampleType"
                                          id="sampleType"
                                          classNamePrefix="rs"
                                          className={`${
                                            (amendCase === "CASE3" &&
                                              sample?.disableDelete) ||
                                            amendCase === "CASE4"
                                              ? "rs__control--bg-gray"
                                              : isCancelRequest ||
                                                IsAcknowledgeRequest
                                              ? "rs__control--bg-light-gray"
                                              : "rs__control--bg-initial"
                                          }`}
                                          isDisabled={
                                            (amendCase === "CASE3" &&
                                              sample?.disableDelete) ||
                                            amendCase === "CASE4" ||
                                            isCancelRequest ||
                                            IsAcknowledgeRequest
                                          }
                                          options={[
                                            ...(sampletypeOptions?.map(
                                              (option) => ({
                                                label: option.name,
                                                value: option.name,
                                                id: option.id,
                                              })
                                            ) || []),
                                          ]}
                                          value={
                                            sample.sampleType
                                              ? {
                                                  label: sample.sampleType,
                                                  value: sample.sampleType,
                                                }
                                              : null
                                          }
                                          onChange={(selectedOption) => {
                                            if (selectedOption) {
                                              handleSampleTypeChange(
                                                index,
                                                selectedOption
                                              );
                                            }
                                          }}
                                        />

                                        {sample.sampleType === "OTHERS" && (
                                          <input
                                            type="text"
                                            name="sampleTypeText"
                                            className={`form-control mt-2 ${
                                              sample?.sampleTypeErrMsg
                                                ? "border-danger"
                                                : ""
                                            } csp-fw-900 ${
                                              (amendCase === "CASE3" &&
                                                sample?.disableDelete) ||
                                              amendCase === "CASE4"
                                                ? "csp-bg-light-gray"
                                                : isCancelRequest ||
                                                  IsAcknowledgeRequest
                                                ? "csp-bg-disabled"
                                                : "csp-bg-initial"
                                            }`}
                                            disabled={
                                              (amendCase === "CASE3" &&
                                                sample?.disableDelete) ||
                                              amendCase === "CASE4" ||
                                              isCancelRequest ||
                                              IsAcknowledgeRequest
                                            }
                                            placeholder="Enter Sample Type"
                                            value={sample.sampleTypeText || ""}
                                            onChange={(e) =>
                                              handleFormChange(
                                                index,
                                                "string"
                                              )(e)
                                            }
                                          />
                                        )}

                                        {sample?.sampleTypeErrMsg && (
                                          <div className="error-message">
                                            <FontAwesomeIcon
                                              className="me-1"
                                              icon={faCircleExclamation}
                                            />
                                            Please fill Sample Type.
                                          </div>
                                        )}
                                      </td>

                                      <td colSpan={2}>
                                        <Select
                                          name="sampleName"
                                          id="sampleName"
                                          classNamePrefix="rs"
                                          className={`${
                                            (amendCase === "CASE3" &&
                                              sample?.disableDelete) ||
                                            amendCase === "CASE4"
                                              ? "rs__control--bg-gray"
                                              : isCancelRequest ||
                                                IsAcknowledgeRequest
                                              ? "rs__control--bg-light-gray"
                                              : "rs__control--bg-initial"
                                          }`}
                                          isDisabled={
                                            (amendCase === "CASE3" &&
                                              sample?.disableDelete) ||
                                            amendCase === "CASE4" ||
                                            isCancelRequest ||
                                            IsAcknowledgeRequest
                                          }
                                          options={[
                                            ...(sample?.sampleNameOptions?.map(
                                              (option) => ({
                                                label: option.name,
                                                value: option.name,
                                              })
                                            ) || []),
                                          ]}
                                          value={
                                            sample.sampleName
                                              ? {
                                                  label: sample.sampleName,
                                                  value: sample.sampleName,
                                                }
                                              : null
                                          }
                                          onChange={(selectedOption) => {
                                            const newValue =
                                              selectedOption?.value || "";

                                            const updatedSample = {
                                              ...sample,
                                              sampleName: newValue,
                                            };

                                            if (
                                              sample.sampleType?.trim() !==
                                              "POTTING MEDIUM /SOIL"
                                            ) {
                                              updatedSample.scientificName =
                                                sample.sampleNameOptions?.find(
                                                  (opt) => opt.name === newValue
                                                )?.scientificName || "";
                                            }

                                            if (
                                              sample.sampleType?.trim() ===
                                              "POTTING MEDIUM /SOIL"
                                            ) {
                                              updatedSample.sampleDesc =
                                                newValue;
                                            }
                                            if (
                                              sample.sampleType?.trim() ===
                                              "POTTING MEDIUM /SOIL"
                                            ) {
                                              const visibleDesc =
                                                visibleSampleDesc.find(
                                                  (desc) =>
                                                    desc.toLowerCase() ===
                                                    newValue.toLowerCase()
                                                );
                                              updatedSample.sampleDesc =
                                                visibleDesc || newValue;
                                            }
                                            const newSamples = [...samples];
                                            newSamples[index] = updatedSample;
                                            setSamples(newSamples);

                                            if (
                                              sample.sampleType?.trim() ===
                                              "POTTING MEDIUM /SOIL"
                                            ) {
                                              setSelectedSampleDesc((prev) => {
                                                const updated = [...prev];
                                                updated[index] =
                                                  updatedSample.sampleDesc;
                                                return updated;
                                              });
                                            }
                                          }}
                                        />

                                        {sample?.sampleName === "OTHERS" && (
                                          <input
                                            type="text"
                                            name="sampleNameText"
                                            className={`form-control mt-2 ${
                                              sample?.sampleNameErrMsg
                                                ? "border-danger"
                                                : ""
                                            } csp-fw-900 ${
                                              (amendCase === "CASE3" &&
                                                sample?.disableDelete) ||
                                              amendCase === "CASE4"
                                                ? "csp-bg-light-gray"
                                                : isCancelRequest ||
                                                  IsAcknowledgeRequest
                                                ? "csp-bg-disabled"
                                                : "csp-bg-initial"
                                            }`}
                                            disabled={
                                              (amendCase === "CASE3" &&
                                                sample?.disableDelete) ||
                                              amendCase === "CASE4" ||
                                              isCancelRequest ||
                                              IsAcknowledgeRequest
                                            }
                                            placeholder="Enter Sample Name"
                                            value={sample.sampleNameText || ""}
                                            onChange={(e) =>
                                              handleFormChange(
                                                index,
                                                "string"
                                              )(e)
                                            }
                                          />
                                        )}

                                        {sample?.sampleNameErrMsg && (
                                          <div className="error-message">
                                            <FontAwesomeIcon
                                              className="me-1"
                                              icon={faCircleExclamation}
                                            />
                                            Please fill Sample Name.
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan={2}>
                                        <label
                                          htmlFor="sampleDesc"
                                          className="col-form-label"
                                        >
                                          Sample Description
                                          <span className="star-red">*</span>
                                        </label>
                                        <Select
                                          name="sampleDesc"
                                          id="sampleDescription"
                                          classNamePrefix="rs"
                                          className={`${
                                            (amendCase === "CASE3" &&
                                              sample?.disableDelete) ||
                                            amendCase === "CASE4"
                                              ? "rs__control--bg-gray"
                                              : isCancelRequest ||
                                                IsAcknowledgeRequest
                                              ? "rs__control--bg-light-gray"
                                              : "rs__control--bg-initial"
                                          }`}
                                          isDisabled={
                                            (amendCase === "CASE3" &&
                                              sample?.disableDelete) ||
                                            amendCase === "CASE4" ||
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            sample.sampleType ===
                                              "POTTING MEDIUM /SOIL"
                                          }
                                          options={
                                            descriptionOptions[index]?.map(
                                              (descOption) => ({
                                                label: descOption,
                                                value: descOption,
                                              })
                                            ) || []
                                          }
                                          value={
                                            sample.sampleDesc
                                              ? {
                                                  label: sample.sampleDesc,
                                                  value: sample.sampleDesc,
                                                }
                                              : null
                                          }
                                          onChange={(selectedOption) => {
                                            handleFormChange(
                                              index,
                                              "string"
                                            )({
                                              target: {
                                                name: "sampleDesc",
                                                value:
                                                  selectedOption?.value || "",
                                              },
                                            } as any);
                                          }}
                                        />

                                        {sample?.sampleDesc === "Others" && (
                                          <input
                                            type="text"
                                            name="sampleDescText"
                                            className={`form-control mt-2 csp-fw-900 ${
                                              (amendCase === "CASE3" &&
                                                sample?.disableDelete) ||
                                              amendCase === "CASE4"
                                                ? "csp-bg-light-gray"
                                                : isCancelRequest ||
                                                  IsAcknowledgeRequest
                                                ? "csp-bg-disabled"
                                                : "csp-bg-initial"
                                            }`}
                                            placeholder="Enter Sample Description"
                                            value={sample.sampleDescText || ""}
                                            disabled={
                                              (amendCase === "CASE3" &&
                                                sample?.disableDelete) ||
                                              amendCase === "CASE4" ||
                                              isCancelRequest ||
                                              IsAcknowledgeRequest
                                            }
                                            onChange={(e) =>
                                              handleFormChange(
                                                index,
                                                "string"
                                              )(e)
                                            }
                                          />
                                        )}

                                        {sample?.sampleDescErrMsg && (
                                          <div className="error-message">
                                            <FontAwesomeIcon
                                              className="me-1"
                                              icon={faCircleExclamation}
                                            />
                                            Please fill Sample Description.
                                          </div>
                                        )}
                                      </td>

                                      <td colSpan={2}>
                                        <label
                                          htmlFor="scientificName"
                                          className="col-form-label"
                                        >
                                          Scientific Name
                                        </label>
                                        <Select
                                          id="scientificName"
                                          name="scientificName"
                                          classNamePrefix="rs"
                                          className={`${
                                            (amendCase === "CASE3" &&
                                              sample?.disableDelete) ||
                                            amendCase === "CASE4"
                                              ? "rs__control--bg-gray"
                                              : isCancelRequest ||
                                                IsAcknowledgeRequest
                                              ? "rs__control--bg-light-gray"
                                              : "rs__control--bg-initial"
                                          }`}
                                          isDisabled={
                                            (amendCase === "CASE3" &&
                                              sample?.disableDelete) ||
                                            amendCase === "CASE4" ||
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            sample.sampleType ===
                                              "POTTING MEDIUM /SOIL"
                                          }
                                          options={
                                            sample?.scientificNameOptions?.map(
                                              (nameOption: any) => ({
                                                value: nameOption,
                                                label: nameOption,
                                              })
                                            ) || []
                                          }
                                          value={
                                            sample.sampleType ===
                                            "POTTING MEDIUM /SOIL"
                                              ? null
                                              : sample.scientificName
                                              ? {
                                                  value: sample.scientificName,
                                                  label: sample.scientificName,
                                                }
                                              : null
                                          }
                                          onChange={(selectedOption) =>
                                            handleFormChange(
                                              index,
                                              "text"
                                            )({
                                              name: "scientificName",
                                              value:
                                                selectedOption?.value || "",
                                            })
                                          }
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="fnt-wg">
                                        <div className="mb-2 ">
                                          <label
                                            htmlFor="gpsCoordinate"
                                            className="col-form-label"
                                          >
                                            Sample Marking
                                            <span className="star-red">*</span>
                                          </label>

                                          <div className="pos-rel">
                                            <input
                                              type="text"
                                              className={`form-control ${
                                                sample?.markingErrMsg
                                                  ? "border-danger"
                                                  : ""
                                              } ${
                                                isCancelRequest ||
                                                IsAcknowledgeRequest
                                                  ? "csp-bg-disabled"
                                                  : "csp-bg-initial"
                                              }`}
                                              aria-label="Sample Marking"
                                              id="marking"
                                              name="marking"
                                              value={sample.marking}
                                              onChange={handleFormChange(
                                                index,
                                                "string"
                                              )}
                                              maxLength={100}
                                              disabled={
                                                isCancelRequest ||
                                                IsAcknowledgeRequest
                                              }
                                            />
                                            {sample?.markingErrMsg && (
                                              <div className="error-message">
                                                <FontAwesomeIcon
                                                  className="me-1"
                                                  icon={faCircleExclamation}
                                                />
                                                {sample.markingErrMsg}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </td>
                                      <td className="fnt-wg">
                                        <div className="mb-2 ">
                                          <label
                                            htmlFor="samplingDate"
                                            className="col-form-label"
                                          >
                                            Sampling Date & Time
                                            <span className="star-red">*</span>
                                          </label>

                                          <input
                                            type="datetime-local"
                                            className={`form-control ${
                                              sample?.samplingDateErrMsg
                                                ? "border-danger"
                                                : ""
                                            } ${
                                              isCancelRequest ||
                                              amendCase == "CASE4" ||
                                              amendCase == "CASE3" ||
                                              IsAcknowledgeRequest
                                                ? "csp-bg-disabled"
                                                : "csp-bg-initial"
                                            }`}
                                            id="samplingDate"
                                            name="samplingDate"
                                            max={maxDateTime}
                                            value={
                                              sample.samplingDate
                                                ? moment(
                                                    sample.samplingDate,
                                                    "DD/MM/YYYY hh:mm A"
                                                  ).format("YYYY-MM-DDTHH:mm")
                                                : ""
                                            }
                                            disabled={
                                              amendCase == "CASE4" ||
                                              amendCase == "CASE3" ||
                                              isCancelRequest ||
                                              IsAcknowledgeRequest
                                            }
                                            onChange={handleFormChange(
                                              index,
                                              "datetime-local"
                                            )}
                                            required
                                          />
                                          {sample?.samplingDateErrMsg && (
                                            <div className="error-message">
                                              <FontAwesomeIcon
                                                className="me-1"
                                                icon={faCircleExclamation}
                                              />
                                              Please fill Sampling Date.
                                            </div>
                                          )}
                                        </div>
                                      </td>

                                      <td className="fnt-wg">
                                        <div className="mb-2 ">
                                          <label
                                            htmlFor="gpsCoordinate"
                                            className="col-form-label"
                                          >
                                            Test Information
                                            <span className="star-red">*</span>
                                          </label>

                                          <div className="pos-rel"></div>
                                          <button
                                            className={`btn btn-outline-success w-100 ${
                                              sample?.labTestDetailsErrMsg
                                                ? "border-danger"
                                                : ""
                                            }`}
                                            type="button"
                                            onClick={() =>
                                              handleShowSearchTestsModal(index)
                                            }
                                            disabled={
                                              amendCase == "CASE4" ||
                                              amendCase == "CASE3" ||
                                              isCancelRequest ||
                                              IsAcknowledgeRequest
                                            }
                                          >
                                            Search Test
                                          </button>

                                          {sample?.labTestDetailsErrMsg && (
                                            <div className="error-message">
                                              <FontAwesomeIcon
                                                className="me-1"
                                                icon={faCircleExclamation}
                                              />
                                              Please add Test Information.
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                    </tr>

                                    {/* <tr>
                                      <td className="fnt-wg" colSpan={3}>
                                        {sample.labTestDetails &&
                                          sample.labTestDetails.map(
                                            (test, testIndex) => (
                                              <div
                                                className="test-detail"
                                                key={testIndex}
                                              >
                                                <span className="test-description">
                                                  {test.testDescription}
                                                </span>
                                                {!test.isInitialSelected &&
                                                  !(
                                                    amendCase === "CASE3" &&
                                                    test?.disableDelete
                                                  ) &&
                                                  amendCase !== "CASE4" &&
                                                  !isCancelRequest &&
                                                  !IsAcknowledgeRequest && (
                                                    <span
                                                      className="test-remove-icon"
                                                      onClick={() =>
                                                        handleRemoveTest(
                                                          sample.labTestDetails,
                                                          test.testDescription,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      <i className="bi bi-dash-circle"></i>
                                                    </span>
                                                  )}
                                              </div>
                                            )
                                          )}
                                      </td>
                                    </tr> */}

                                    <tr>
                                      <td className="fnt-wg" colSpan={3}>
                                        {sample.labTestDetails &&
                                          sample.labTestDetails.map(
                                            (test, testIndex) => {
                                              const isManganesePresent =
                                                sample.labTestDetails.some(
                                                  (t) =>
                                                    t.testDescription.toLowerCase() ===
                                                    "manganese"
                                                );

                                              const isPHTest =
                                                test.testDescription.toLowerCase() ===
                                                "ph";
                                              const disablePHRemoval =
                                                isPHTest && isManganesePresent;

                                              return (
                                                <div
                                                  className="test-detail"
                                                  key={testIndex}
                                                >
                                                  <span className="test-description">
                                                    {test.testDescription}
                                                  </span>
                                                  {!test.isInitialSelected &&
                                                    !(
                                                      amendCase === "CASE3" &&
                                                      test?.disableDelete
                                                    ) &&
                                                    amendCase !== "CASE4" &&
                                                    !isCancelRequest &&
                                                    !IsAcknowledgeRequest &&
                                                    !disablePHRemoval && (
                                                      <span
                                                        className="test-remove-icon"
                                                        onClick={() =>
                                                          handleRemoveTest(
                                                            sample.labTestDetails,
                                                            test.testDescription,
                                                            index
                                                          )
                                                        }
                                                      >
                                                        <i className="bi bi-dash-circle"></i>
                                                      </span>
                                                    )}
                                                </div>
                                              );
                                            }
                                          )}
                                      </td>
                                    </tr>

                                    <>
                                      <a
                                        href="#"
                                        className="othersample"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleContentToggle(index);
                                        }}
                                      >
                                        Other Sample Details
                                        {!expandedSampleIndices.includes(index)
                                          ? "[-]"
                                          : "[+]"}
                                      </a>

                                      {!expandedSampleIndices.includes(
                                        index
                                      ) && (
                                        <>
                                          <tr>
                                            <td className="fnt-wg" colSpan={2}>
                                              <div className="mb-2">
                                                <label
                                                  htmlFor="selectedDistrict"
                                                  className="col-form-label float-start"
                                                >
                                                  District
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </label>
                                                <div className="input-group pos-rel">
                                                  <input
                                                    type="text"
                                                    id="selectedDistrict"
                                                    className={`form-control ${
                                                      sample?.districtErrMsg
                                                        ? "border-danger"
                                                        : ""
                                                    } ${
                                                      isCancelRequest ||
                                                      amendCase === "CASE4" ||
                                                      amendCase === "CASE3" ||
                                                      IsAcknowledgeRequest
                                                        ? "csp-bg-disabled"
                                                        : "csp-bg-initial"
                                                    }`}
                                                    disabled={
                                                      isCancelRequest ||
                                                      amendCase === "CASE4" ||
                                                      amendCase === "CASE3" ||
                                                      IsAcknowledgeRequest
                                                    }
                                                    placeholder=""
                                                    value={sample.district}
                                                    onChange={handleFormChange(
                                                      index,
                                                      "string"
                                                    )}
                                                    readOnly
                                                    onClick={() => {
                                                      if (
                                                        !(
                                                          isCancelRequest ||
                                                          IsAcknowledgeRequest ||
                                                          amendCase ===
                                                            "CASE4" ||
                                                          amendCase === "CASE3"
                                                        )
                                                      ) {
                                                        handleShowDistrictSearchModal(
                                                          index
                                                        );
                                                      }
                                                    }}
                                                  />
                                                </div>
                                                {sample?.districtErrMsg && (
                                                  <div className="error-message">
                                                    <FontAwesomeIcon
                                                      className="me-1"
                                                      icon={faCircleExclamation}
                                                    />
                                                    Please fill District.
                                                  </div>
                                                )}
                                              </div>
                                            </td>

                                            <td className="fnt-wg">
                                              <div className="mb-2 ">
                                                <label
                                                  htmlFor="severity"
                                                  className="col-form-label"
                                                >
                                                  Severity
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </label>

                                                <div className="pos-rel">
                                                  <select
                                                    className={`form-select ${
                                                      sample?.severityErrMsg
                                                        ? "border-danger"
                                                        : ""
                                                    } ${
                                                      amendCase == "CASE3" ||
                                                      amendCase == "CASE4" ||
                                                      isCancelRequest ||
                                                      IsAcknowledgeRequest
                                                        ? "csp-bg-disabled"
                                                        : "csp-bg-initial"
                                                    }`}
                                                    disabled={
                                                      amendCase == "CASE3" ||
                                                      amendCase == "CASE4" ||
                                                      isCancelRequest ||
                                                      IsAcknowledgeRequest
                                                    }
                                                    aria-label="Default select example"
                                                    id="severity"
                                                    name="severity"
                                                    value={sample.severity}
                                                    onChange={handleFormChange(
                                                      index,
                                                      "number"
                                                    )}
                                                  >
                                                    <option value=""></option>
                                                    {severityOptions &&
                                                      severityOptions.map(
                                                        (descOption, index) => (
                                                          <option
                                                            key={index}
                                                            value={
                                                              descOption.id
                                                            }
                                                          >
                                                            {descOption.name}
                                                          </option>
                                                        )
                                                      )}
                                                  </select>
                                                  {sample?.severityErrMsg && (
                                                    <div className="error-message">
                                                      <FontAwesomeIcon
                                                        className="me-1"
                                                        icon={
                                                          faCircleExclamation
                                                        }
                                                      />
                                                      Please fill Severity.
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="fnt-wg">
                                              <div className="mb-3 ">
                                                <label
                                                  htmlFor="selectedCountry"
                                                  className="col-form-label"
                                                >
                                                  Country
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </label>

                                                <div className="input-group rounded">
                                                  <input
                                                    type="text"
                                                    id="selectedCountry"
                                                    className={`form-control rounded-start ${
                                                      sample?.countryErrMsg
                                                        ? "border-danger"
                                                        : ""
                                                    }`}
                                                    placeholder=""
                                                    value={sample.country}
                                                    onChange={handleFormChange(
                                                      index,
                                                      "string"
                                                    )}
                                                    aria-label="Country"
                                                    aria-describedby="search-addon"
                                                    name="country"
                                                    disabled
                                                  />
                                                </div>
                                                {sample?.countryErrMsg && (
                                                  <div className="error-message">
                                                    <FontAwesomeIcon
                                                      className="me-1"
                                                      icon={faCircleExclamation}
                                                    />
                                                    Please fill Country.
                                                  </div>
                                                )}
                                              </div>
                                            </td>
                                            <td className="fnt-wg">
                                              <div className="mb-3 ">
                                                <label
                                                  htmlFor="selectedSampleLocation"
                                                  className="col-form-label float-start"
                                                >
                                                  Sample Location
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </label>

                                                <input
                                                  type="text"
                                                  className={`form-control ${
                                                    sample?.sampleLocationErrMsg
                                                      ? "border-danger"
                                                      : ""
                                                  }`}
                                                  aria-label="Sample Location"
                                                  id="selectedSampleLocation"
                                                  name="sampleLocation"
                                                  value={
                                                    sampleLocationMapping[
                                                      sample.sampleLocation
                                                    ] || ""
                                                  }
                                                  onChange={handleFormChange(
                                                    index,
                                                    "string"
                                                  )}
                                                  disabled
                                                />
                                                {sample?.sampleLocationErrMsg && (
                                                  <div className="error-message">
                                                    <FontAwesomeIcon
                                                      className="me-1"
                                                      icon={faCircleExclamation}
                                                    />
                                                    Please fill Sample location.
                                                  </div>
                                                )}
                                              </div>
                                            </td>
                                            <td className="fnt-wg">
                                              <div className="mb-2">
                                                <label
                                                  htmlFor="signsSymptoms"
                                                  className="col-form-label"
                                                >
                                                  Signs/Symptoms
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </label>

                                                <Select
                                                  isMulti
                                                  name="signsOrSymptoms"
                                                  classNamePrefix="rs"
                                                  className={`basic-multi-select ${
                                                    sample?.signsOrSymptomsErrMsg
                                                      ? "border-danger"
                                                      : ""
                                                  } ${
                                                    amendCase == "CASE3" ||
                                                    amendCase == "CASE4"
                                                      ? "rs__control--bg-gray"
                                                      : isCancelRequest ||
                                                        IsAcknowledgeRequest
                                                      ? "rs__control--bg-light-gray"
                                                      : "rs__control--bg-initial"
                                                  }`}
                                                  isDisabled={
                                                    amendCase == "CASE3" ||
                                                    amendCase == "CASE4" ||
                                                    isCancelRequest ||
                                                    IsAcknowledgeRequest
                                                  }
                                                  options={signOrSymptomsOptions}
                                                  value={
                                                    Array.isArray(
                                                      sample.signsOrSymptoms
                                                    )
                                                      ? sample.signsOrSymptoms.map(
                                                          (value) => ({
                                                            label: value,
                                                            value: value,
                                                          })
                                                        )
                                                      : sample.signsOrSymptoms ===
                                                        "Others"
                                                      ? [
                                                          {
                                                            label: "Others",
                                                            value: "Others",
                                                          },
                                                        ]
                                                      : []
                                                  }
                                                  onChange={(selectedOptions) =>
                                                    handleSelect(
                                                      selectedOptions,
                                                      index
                                                    )
                                                  }
                                                />

                                                {selectedOptions &&
                                                  (
                                                    selectedOptions as any[]
                                                  ).some(
                                                    (option: any) =>
                                                      option.value === "Others"
                                                  ) && (
                                                    <input
                                                      type="text"
                                                      disabled={
                                                        amendCase == "CASE3" ||
                                                        amendCase == "CASE4" ||
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest
                                                      }
                                                      className={`form-control mt-2 ${
                                                        amendCase ==
                                                          "CASE3" ||
                                                        amendCase ==
                                                          "CASE4" ||
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest
                                                          ? "csp-bg-disabled"
                                                          : "csp-bg-initial"
                                                      }`}
                                                      name="signsOrSymptomsText"
                                                      placeholder="Enter Signs/Symptoms"
                                                      value={
                                                        sample.signsOrSymptomsText
                                                      }
                                                      onChange={handleFormChange(
                                                        index,
                                                        "string"
                                                      )}
                                                    />
                                                  )}

                                                {sample?.signsOrSymptomsErrMsg && (
                                                  <div className="error-message">
                                                    <FontAwesomeIcon
                                                      className="me-1"
                                                      icon={faCircleExclamation}
                                                    />
                                                    Please fill Signs/Symptoms.
                                                  </div>
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="fnt-wg">
                                              <div className="mb-2 ">
                                                <label
                                                  htmlFor="latitude"
                                                  className="col-form-label"
                                                >
                                                  Latitude (Decimal Degrees)
                                                </label>

                                                <div className="pos-rel">
                                                  <input
                                                    type="text"
                                                    className={`form-control ${
                                                      amendCase == "CASE3" ||
                                                      amendCase == "CASE4" ||
                                                      isCancelRequest ||
                                                      IsAcknowledgeRequest
                                                        ? "csp-bg-disabled"
                                                        : "csp-bg-initial"
                                                    }`}
                                                    name="latitude"
                                                    id="latitude"
                                                    disabled={
                                                      amendCase == "CASE3" ||
                                                      amendCase == "CASE4" ||
                                                      isCancelRequest ||
                                                      IsAcknowledgeRequest
                                                    }
                                                    maxLength={100}
                                                    placeholder="123.123456"
                                                    value={sample.latitude}
                                                    onChange={handleFormChange(
                                                      index,
                                                      "string"
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            </td>

                                            <td className="fnt-wg">
                                              <div className="mb-2 ">
                                                <label
                                                  htmlFor="longitude"
                                                  className="col-form-label"
                                                >
                                                  Longitude (Decimal Degrees)
                                                </label>

                                                <div className="pos-rel">
                                                  <input
                                                    type="text"
                                                    className={`form-control ${
                                                      amendCase == "CASE3" ||
                                                      amendCase == "CASE4" ||
                                                      isCancelRequest ||
                                                      IsAcknowledgeRequest
                                                        ? "csp-bg-disabled"
                                                        : "csp-bg-initial"
                                                    }`}
                                                    name="longitude"
                                                    id="longitude"
                                                    disabled={
                                                      amendCase == "CASE3" ||
                                                      amendCase == "CASE4" ||
                                                      isCancelRequest ||
                                                      IsAcknowledgeRequest
                                                    }
                                                    maxLength={100}
                                                    placeholder="123.123456"
                                                    value={sample.longitude}
                                                    onChange={handleFormChange(
                                                      index,
                                                      "string"
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            </td>

                                            <td className="fnt-wg">
                                              <div className="mb-2 ">
                                                <label
                                                  htmlFor="diseaseDistribution"
                                                  className="col-form-label"
                                                >
                                                  Disease Distribution
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </label>

                                                <select
                                                  className={`form-select ${
                                                    sample?.diseaseDistributionErrMsg
                                                      ? "border-danger"
                                                      : ""
                                                  } ${
                                                    amendCase == "CASE3" ||
                                                    amendCase == "CASE4" ||
                                                    isCancelRequest ||
                                                    IsAcknowledgeRequest
                                                      ? "csp-bg-disabled"
                                                      : "csp-bg-initial"
                                                  }`}
                                                  disabled={
                                                    amendCase == "CASE3" ||
                                                    amendCase == "CASE4" ||
                                                    isCancelRequest ||
                                                    IsAcknowledgeRequest
                                                  }
                                                  aria-label="Default select example"
                                                  name="diseaseDistribution"
                                                  id="diseaseDistribution"
                                                  value={
                                                    sample.diseaseDistribution
                                                  }
                                                  onChange={handleFormChange(
                                                    index,
                                                    "string"
                                                  )}
                                                >
                                                  <option value=""></option>
                                                  {diseaseDistributionOptions &&
                                                    diseaseDistributionOptions.map(
                                                      (descOption, index) => (
                                                        <option
                                                          key={index}
                                                          value={
                                                            descOption.name
                                                          }
                                                        >
                                                          {descOption.name}
                                                        </option>
                                                      )
                                                    )}
                                                </select>
                                                {sample?.diseaseDistributionErrMsg && (
                                                  <div className="error-message">
                                                    <FontAwesomeIcon
                                                      className="me-1"
                                                      icon={faCircleExclamation}
                                                    />
                                                    Please fill Disease
                                                    Distribution.
                                                  </div>
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </>
                                      )}
                                    </>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                  {isCancelRequest ? (
                    <div className="personal-info">
                      <div className="clonable-block" data-toggle="cloner">
                        <div className="clonable" data-clone-number="1">
                          <div className="info-heading">
                            <h2>
                              Reason(s) for cancellation
                              <span className="star-red">*</span>
                            </h2>
                          </div>
                          <div className="info-content">
                            <textarea
                              className="form-control"
                              placeholder=""
                              name="cancel-request-comments"
                              value={cancelComments}
                              onChange={(e) =>
                                setCancelComments(e.target.value)
                              }
                              disabled={cancelButtonHidden}
                            ></textarea>
                            {cancelCommentsErrMsg && (
                              <div className="error-message">
                                <FontAwesomeIcon
                                  className="me-1"
                                  icon={faCircleExclamation}
                                />
                                Please fill Reason(s) for cancellation
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Tab>
                <Tab eventKey={2} title="My Preference">
                  <div className="row setup-content" id="step-3">
                    <div className="col-md-12">
                      <div className="tab-wizard-content">
                        <div className="personal-info">
                          <div className="info-heading">
                            <h2>Project Details</h2>
                          </div>
                          <div className="info-content">
                            <form>
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="mb-3 row">
                                    <label
                                      className="col-sm-4 col-form-label"
                                      htmlFor="showProjectInput"
                                    >
                                      Project Name/Location to be reflected in
                                      the report
                                    </label>
                                    <div className="col-sm-8">
                                      <select
                                        className="form-select"
                                        id="showProjectInput"
                                        name="showProjectInput"
                                        value={projectDetails?.showProjectInput}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest
                                        }
                                        onChange={handleMyPreference}
                                      >
                                        <option value="">---select---</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                      </select>

                                      {/* {!projectDetails?.showProjectInput &&
                                          nextClicked && (
                                            <div className="error-message">
                                              <FontAwesomeIcon
                                                className="me-1"
                                                icon={faCircleExclamation}
                                              />
                                              Please select Project
                                              Name/Location to be reflected in
                                              the report.
                                              <span className="star-red">
                                                *
                                              </span>
                                            </div>
                                          )} */}
                                    </div>
                                  </div>

                                  {projectDetails?.showProjectInput ===
                                    "Yes" && (
                                    <div className="mb-3 row">
                                      <label
                                        htmlFor="projectName"
                                        className="col-sm-4 col-form-label"
                                      >
                                        Enter Project Name / Location for Report
                                        <span className="star-red">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            isCancelRequest ||
                                            IsAcknowledgeRequest
                                              ? "csp-bg-disabled"
                                              : "csp-bg-initial"
                                          }`}
                                          placeholder=""
                                          name="projectName"
                                          value={projectDetails?.projectName}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest
                                          }
                                          onChange={handleMyPreference}
                                          maxLength={100}
                                        />

                                        {projectDetails?.projectNameErrMsg && (
                                          <div className="error-message">
                                            <FontAwesomeIcon
                                              className="me-1"
                                              icon={faCircleExclamation}
                                            />
                                            Please Enter Project Name for
                                            Report.
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <div className="col-lg-6">
                                  <div className="mb-3 row">
                                    <label
                                      htmlFor="inputGroupFile04"
                                      className="col-sm-4 col-form-label"
                                      onMouseEnter={handleMouseEnter}
                                      onMouseLeave={handleMouseLeave}
                                      title="Documents allowed:pdf,docx,doc,jpg,jpeg,png,xlsx,xls."
                                    >
                                      Support Documents
                                      <span className="csp-ml-5">
                                        <FontAwesomeIcon icon={faInfoCircle} />
                                      </span>
                                    </label>
                                    <div className="col-sm-8">
                                      <div className="input-group">
                                        <input
                                          type="file"
                                          className={`form-control ${
                                            amendCase == "CASE3" ||
                                            amendCase == "CASE4" ||
                                            isCancelRequest ||
                                            IsAcknowledgeRequest
                                              ? "csp-bg-disabled"
                                              : "csp-bg-initial"
                                          }`}
                                          id="inputGroupFile04"
                                          onChange={handleFileChange}
                                          disabled={
                                            amendCase == "CASE3" ||
                                            amendCase == "CASE4" ||
                                            isCancelRequest ||
                                            IsAcknowledgeRequest
                                          }
                                        />
                                      </div>
                                      {projectDetails?.attachmentName ? (
                                        <div className="file-view">
                                          {projectDetails?.attachmentName}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="mb-3 row">
                                    <label
                                      htmlFor="specialInstructions"
                                      className="col-sm-4 col-form-label"
                                    >
                                      Special Instructions/Additional
                                      Information{" "}
                                    </label>
                                    <div className="col-sm-8">
                                      <textarea
                                        className={`form-control ${
                                          amendCase == "CASE3" ||
                                          amendCase == "CASE4" ||
                                          isCancelRequest ||
                                          IsAcknowledgeRequest
                                            ? "csp-bg-disabled"
                                            : "csp-bg-initial"
                                        }`}
                                        placeholder=""
                                        name="specialInstruction"
                                        value={
                                          projectDetails?.specialInstruction
                                        }
                                        disabled={
                                          amendCase == "CASE3" ||
                                          amendCase == "CASE4" ||
                                          isCancelRequest ||
                                          IsAcknowledgeRequest
                                        }
                                        maxLength={500}
                                        onChange={handleMyPreference}
                                      ></textarea>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="mb-3 row">
                                    <label
                                      htmlFor="otherRemarks"
                                      className="col-sm-4 col-form-label"
                                    >
                                      Other Remarks
                                    </label>
                                    <div className="col-sm-8">
                                      <textarea
                                        className={`form-control ${
                                          amendCase == "CASE3" ||
                                          amendCase == "CASE4" ||
                                          isCancelRequest ||
                                          IsAcknowledgeRequest
                                            ? "csp-bg-disabled"
                                            : "csp-bg-initial"
                                        }`}
                                        placeholder=""
                                        name="otherRemarks"
                                        value={projectDetails?.otherRemarks}
                                        onChange={handleMyPreference}
                                        disabled={
                                          amendCase == "CASE3" ||
                                          amendCase == "CASE4" ||
                                          isCancelRequest ||
                                          IsAcknowledgeRequest
                                        }
                                        maxLength={500}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>

              <div className="text-end mt-3 mb-3">
                <button
                  className="btn btn-d btn-secondary px-4"
                  onClick={handlePreviousClick}
                >
                  Previous
                </button>

                {!IsAcknowledgeRequest && !isCancelRequest && (
                  <>
                    {actionType !== TypeOfApplicationEnum.amendment && (
                      <button
                        className="btn btn-d btn-secondry  px-4"
                        onClick={handleSaveDraftClick}
                        disabled={btnNameForLoader === "submit-req"}
                      >
                        {btnNameForLoader === "submit-req"
                          ? "Submitting..."
                          : "Save Draft"}
                      </button>
                    )}
                    <button
                      className="btn btn-d btn-primary nextBtn"
                      name="next-click"
                      type="button"
                      onClick={validateForm}
                    >
                      Next
                      {btnNameForLoader == "next-click" ? (
                        <Spinner
                          className="btn-spinner"
                          animation="border"
                          variant="light"
                        />
                      ) : (
                        ""
                      )}
                    </button>
                  </>
                )}
                {!IsAcknowledgeRequest &&
                  !cancelButtonHidden &&
                  isCancelRequest && (
                    <button
                      className="btn btn-d btn-primary nextBtn"
                      name="cancel-request-btn"
                      type="button"
                      onClick={cancelRequest}
                      disabled={btnNameForLoader === "cancel-request-btn"}
                    >
                      Cancel Request
                      {btnNameForLoader == "cancel-request-btn" ? (
                        <Spinner
                          className="btn-spinner"
                          animation="border"
                          variant="light"
                        />
                      ) : (
                        ""
                      )}
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>
      </Container>

      {amendCase === "CASE4" ||
      amendCase === "CASE3" ||
      IsAcknowledgeRequest ||
      isCancelRequest ? (
        ""
      ) : (
        <Modal
          className="popup-2"
          show={showSearchTestsModal}
          onHide={handleCloseSearchTestsModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Assign Tests</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {modalLoader ? (
              <Loader />
            ) : (
              <form onSubmit={handleFormSubmit}>
                <h3>Search for Tests</h3>
                {searchInd !== null && (
                  <div className="tests-cnt pb-2">
                    <div className="mb-3 row">
                      <label
                        htmlFor={`flexCheckDesc-${searchInd}`}
                        className="col-sm-3 col-form-label"
                      >
                        Test Type
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="form-select"
                          value={selectionOption}
                          onChange={handleOptionChange}
                        >
                          {visibleSampleDesc.includes(
                            selectedSampleDesc[searchInd]
                          ) ? (
                            <>
                              <option value="">Select an option</option>
                              <option value="individualTest">
                                Individual Test
                              </option>
                              <option value="package">Package</option>
                            </>
                          ) : (
                            <option value="individualTest">
                              Individual Test
                            </option>
                          )}
                        </select>
                      </div>
                    </div>
                    {selectionOption === "package" && (
                      <div className="mb-3 row">
                        <label
                          htmlFor={`testPackageSelect-${searchInd}`}
                          className="col-sm-3 col-form-label"
                        >
                          Test Package
                        </label>
                        <div className="col-sm-9">
                          <select
                            className="form-select"
                            id={`testPackageSelect-${searchInd}`}
                            aria-label="Test Laboratory"
                            onChange={handlePackageSelect}
                          >
                            <option value="">Select Test Package</option>
                            {packages.map((packageName: any, i: number) => (
                              <option key={i} value={packageName}>
                                {packageName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                    <div className="mb-1 row"></div>
                    <div className="mb-3 row">
                      {selectionOption === "individualTest" && (
                        <>
                          <label
                            htmlFor={`flexCheckDesc-${searchInd}`}
                            className="col-sm-3 col-form-label"
                          >
                            Test Description
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              id={`flexCheckDesc-${searchInd}`}
                              placeholder=""
                              autoComplete="off"
                              value={testDescription}
                              required
                              onChange={(e) =>
                                setTestDescription(e.target.value)
                              }
                              disabled={isCancelRequest || IsAcknowledgeRequest}
                              className={`form-control ${
                                !testDescription ? "border-danger op05" : ""
                              } ${
                                isCancelRequest || IsAcknowledgeRequest
                                  ? "csp-bg-disabled"
                                  : "csp-bg-initial"
                              }`}
                            />
                          </div>
                        </>
                      )}
                      <div className="mb-2 row"></div>
                      <div className="col-sm-12">
                        <Button
                          variant="primary"
                          className="float-end"
                          name="submit-reqq"
                          disabled={searchLoading}
                          onClick={(e) => {
                            handleSearch();
                          }}
                        >
                          Search
                          {btnNameForLoader == "submit-reqq" ? (
                            <Spinner
                              className="btn-spinner"
                              animation="border"
                              variant="light"
                            />
                          ) : (
                            ""
                          )}
                        </Button>
                      </div>
                    </div>
                  </div>
                )}

                <h3>Examination/Diagnostic Tests</h3>
                <div
                  className="tests-cnt csp-maxh-200 csp-overflow-y-auto csp-display-block"
                >
                  <h4>Examination/Diagnostic Tests</h4>
                  {testOptions
                    .slice()
                    .sort((a, b) => {
                      if (a.isInitialSelected && b.isInitialSelected) {
                        return a.name.localeCompare(b.name);
                      }
                      if (a.isInitialSelected) return -1;
                      if (b.isInitialSelected) return 1;
                      return a.name.localeCompare(b.name);
                    })
                    .map((test: any, index: number) => (
                      <div className="form-check" key={index}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={test.name}
                          id={`testOption${index}`}
                          checked={
                            selectedTestIds.includes(test.name) ||
                            test.isSelected
                          }
                          onChange={(e) => {
                            toggleTestSelection(
                              test.name,
                              e.target.checked,
                              test.isSelected || checkedTests[test.name]
                            );
                          }}
                          disabled={test.isInitialSelected}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`testOption${index}`}
                        >
                          {test.name}
                        </label>
                      </div>
                    ))}
                </div>
              </form>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSearchTestsModal}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                if (
                  selectionOption === "package" &&
                  selectedTestIds.length < testSelectionLimit
                ) {
                  message(
                    NotifyType.Error,
                    `Please select at least ${testSelectionLimit} tests to proceed.`
                  );
                } else {
                  handleAddTests();
                  handleCloseSearchTestsModal();
                }
              }}
            >
              Add
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/*Search District Modal */}
      <Modal
        show={showDistrictSearchModal}
        onHide={handleCloseDistrictSearchModal}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Search Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="mb-3">
              <label htmlFor="sampleLocation" className="form-label">
                Sample Location
              </label>

              <select
                className="form-select"
                id="sampleLocation"
                value={sampleLocation}
                onChange={handleSampleLocationChange}
                aria-label="Sample Location"
              >
                <option value="" disabled selected>
                  Select Location
                </option>

                {sampleLocationMapping &&
                  Object.keys(sampleLocationMapping).map((option, index) => (
                    <option key={index} value={option}>
                      {sampleLocationMapping[option]}
                    </option>
                  ))}
              </select>
              {LocationError && (
                <div className="text-danger mt-2">
                  <FontAwesomeIcon
                    className="me-1"
                    icon={faCircleExclamation}
                  />
                  {LocationError}
                </div>
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="country" className="form-label">
                Country
              </label>
              <select
                className="form-select"
                id="country"
                value={country}
                aria-label="Country"
                onChange={(e) => {
                  setCountry(e.target.value);
                  setDistrict("Not Applicable");
                  handleCountryChange(e);
                }}
              >
                <option value="" disabled selected>
                  Select a country
                </option>
                {countryOptionsBak &&
                  countryOptionsBak
                    .filter((option) => {
                      const isValidOption =
                        option.name && option.name.trim() !== "";

                      if (sampleLocation === "1") {
                        return isValidOption && option.name === "Singapore";
                      } else if (sampleLocation === "2") {
                        return isValidOption && option.name !== "Singapore";
                      }
                      return isValidOption;
                    })
                    .map((option, index) => (
                      <option
                        key={index}
                        data-guid={option.id}
                        value={option.name}
                      >
                        {option.name}
                      </option>
                    ))}
              </select>
              {countryError && (
                <div className="text-danger mt-2">
                  <FontAwesomeIcon
                    className="me-1"
                    icon={faCircleExclamation}
                  />
                  {countryError}
                </div>
              )}
            </div>

            {(sampleLocation === "1" || sampleLocation === "2") && (
              <div className="mb-3">
                <label htmlFor="district" className="form-label">
                  District
                </label>

                {districtOptions?.length == 0 && (
                  <Select
                    name="district"
                    options={[
                      ...(districtOptions.map((option) => ({
                        label: option.code,
                        value: option.sampleLocID,
                      })) as any),
                      { label: "Not Applicable", value: "notApplicable" },
                    ]}
                    classNamePrefix="rs"
                    placeholder="select a district"
                    value={defaultDistrict}
                    onChange={handleDistrictChange}
                  />
                )}

                {districtOptions?.length > 0 && (
                  <Select
                    name="district"
                    options={[
                      ...(districtOptions.map((option) => ({
                        label: option.code,
                        value: option.sampleLocID,
                      })) as any),
                      { label: "Not Applicable", value: "notApplicable" },
                    ]}
                    classNamePrefix="rs"
                    placeholder="select a district"
                    value={districtOptions?.find(
                      (option: any) =>
                        option.sampleLocID === (samples as any).district
                    )}
                    onChange={handleDistrictChange}
                  />
                )}

                {districtError && (
                  <div className="text-danger mt-2">
                    {" "}
                    <FontAwesomeIcon
                      className="me-1"
                      icon={faCircleExclamation}
                    />
                    {districtError}
                  </div>
                )}
              </div>
            )}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleModalSearch()}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </>
  );
};

export default SamplesAndTests;
